import { useQuery, useInfiniteQuery, type UseQueryOptions, type UseInfiniteQueryOptions, type InfiniteData } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch("https://gateway.thegraph.com/api/132253dc7e9b87e0010d75f7294b792d/subgraphs/id/4Vicyh7DiEGj6aSamLpAhwydcnaU1CPQgvWApWv7H9Rh", {
    method: "POST",
    ...({"headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Bytes: { input: any; output: any; }
  Int8: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
};

export enum Aggregation_Interval {
  Day = 'day',
  Hour = 'hour'
}

export type BlockChangedFilter = {
  number_gte: Scalars['Int']['input'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  number_gte?: InputMaybe<Scalars['Int']['input']>;
};

export type BorrowerStats = {
  __typename?: 'BorrowerStats';
  /** Number of currently active loans for this borrower */
  activeLoans: Scalars['Int']['output'];
  /** The borrower address. */
  borrower: Scalars['Bytes']['output'];
  /** The clearinghouse. */
  clearinghouse: Clearinghouse;
  /** Current active principal borrowed */
  currentBorrowed: Scalars['BigDecimal']['output'];
  /** Current active collateral deposited */
  currentCollateral: Scalars['BigDecimal']['output'];
  /** Current active interest due */
  currentInterestDue: Scalars['BigDecimal']['output'];
  /**
   * Record ID.
   * In the format of `borrower`.
   */
  id: Scalars['String']['output'];
  /** Last updated block number */
  lastUpdateBlock: Scalars['BigInt']['output'];
  /** Last updated timestamp */
  lastUpdateTimestamp: Scalars['BigInt']['output'];
  /** CoolerLoans */
  loans: Array<CoolerLoan>;
  /** Highest number of concurrent active loans this borrower has ever had */
  maxActiveLoans: Scalars['Int']['output'];
  /** Highest total borrowed value this borrower has ever had */
  maxBorrowedValue: Scalars['BigDecimal']['output'];
  /** Total number of defaulted loans for this borrower */
  totalDefaultedLoans: Scalars['Int']['output'];
  /** Total number of loan extensions for this borrower */
  totalLoanExtensions: Scalars['Int']['output'];
  /** Number of loans taken by this borrower. */
  totalLoans: Scalars['Int']['output'];
  /** Total number of repaid loans for this borrower */
  totalRepaidLoans: Scalars['Int']['output'];
};


export type BorrowerStatsLoansArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CoolerLoan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CoolerLoan_Filter>;
};

export type BorrowerStats_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  activeLoans?: InputMaybe<Scalars['Int']['input']>;
  activeLoans_gt?: InputMaybe<Scalars['Int']['input']>;
  activeLoans_gte?: InputMaybe<Scalars['Int']['input']>;
  activeLoans_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  activeLoans_lt?: InputMaybe<Scalars['Int']['input']>;
  activeLoans_lte?: InputMaybe<Scalars['Int']['input']>;
  activeLoans_not?: InputMaybe<Scalars['Int']['input']>;
  activeLoans_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  and?: InputMaybe<Array<InputMaybe<BorrowerStats_Filter>>>;
  borrower?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_contains?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_gt?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_gte?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  borrower_lt?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_lte?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_not?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  clearinghouse?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_?: InputMaybe<Clearinghouse_Filter>;
  clearinghouse_contains?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_ends_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_gt?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_gte?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clearinghouse_lt?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_lte?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_contains?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clearinghouse_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_starts_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentBorrowed?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentBorrowed_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentBorrowed_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentBorrowed_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  currentBorrowed_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentBorrowed_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentBorrowed_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentBorrowed_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  currentCollateral?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentCollateral_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentCollateral_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentCollateral_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  currentCollateral_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentCollateral_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentCollateral_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentCollateral_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  currentInterestDue?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentInterestDue_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentInterestDue_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentInterestDue_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  currentInterestDue_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentInterestDue_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentInterestDue_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  currentInterestDue_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lastUpdateBlock?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastUpdateBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateBlock_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastUpdateTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastUpdateTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  loans_?: InputMaybe<CoolerLoan_Filter>;
  maxActiveLoans?: InputMaybe<Scalars['Int']['input']>;
  maxActiveLoans_gt?: InputMaybe<Scalars['Int']['input']>;
  maxActiveLoans_gte?: InputMaybe<Scalars['Int']['input']>;
  maxActiveLoans_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxActiveLoans_lt?: InputMaybe<Scalars['Int']['input']>;
  maxActiveLoans_lte?: InputMaybe<Scalars['Int']['input']>;
  maxActiveLoans_not?: InputMaybe<Scalars['Int']['input']>;
  maxActiveLoans_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxBorrowedValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  maxBorrowedValue_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  maxBorrowedValue_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  maxBorrowedValue_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  maxBorrowedValue_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  maxBorrowedValue_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  maxBorrowedValue_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  maxBorrowedValue_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  or?: InputMaybe<Array<InputMaybe<BorrowerStats_Filter>>>;
  totalDefaultedLoans?: InputMaybe<Scalars['Int']['input']>;
  totalDefaultedLoans_gt?: InputMaybe<Scalars['Int']['input']>;
  totalDefaultedLoans_gte?: InputMaybe<Scalars['Int']['input']>;
  totalDefaultedLoans_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalDefaultedLoans_lt?: InputMaybe<Scalars['Int']['input']>;
  totalDefaultedLoans_lte?: InputMaybe<Scalars['Int']['input']>;
  totalDefaultedLoans_not?: InputMaybe<Scalars['Int']['input']>;
  totalDefaultedLoans_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLoanExtensions?: InputMaybe<Scalars['Int']['input']>;
  totalLoanExtensions_gt?: InputMaybe<Scalars['Int']['input']>;
  totalLoanExtensions_gte?: InputMaybe<Scalars['Int']['input']>;
  totalLoanExtensions_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLoanExtensions_lt?: InputMaybe<Scalars['Int']['input']>;
  totalLoanExtensions_lte?: InputMaybe<Scalars['Int']['input']>;
  totalLoanExtensions_not?: InputMaybe<Scalars['Int']['input']>;
  totalLoanExtensions_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLoans?: InputMaybe<Scalars['Int']['input']>;
  totalLoans_gt?: InputMaybe<Scalars['Int']['input']>;
  totalLoans_gte?: InputMaybe<Scalars['Int']['input']>;
  totalLoans_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLoans_lt?: InputMaybe<Scalars['Int']['input']>;
  totalLoans_lte?: InputMaybe<Scalars['Int']['input']>;
  totalLoans_not?: InputMaybe<Scalars['Int']['input']>;
  totalLoans_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalRepaidLoans?: InputMaybe<Scalars['Int']['input']>;
  totalRepaidLoans_gt?: InputMaybe<Scalars['Int']['input']>;
  totalRepaidLoans_gte?: InputMaybe<Scalars['Int']['input']>;
  totalRepaidLoans_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalRepaidLoans_lt?: InputMaybe<Scalars['Int']['input']>;
  totalRepaidLoans_lte?: InputMaybe<Scalars['Int']['input']>;
  totalRepaidLoans_not?: InputMaybe<Scalars['Int']['input']>;
  totalRepaidLoans_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum BorrowerStats_OrderBy {
  ActiveLoans = 'activeLoans',
  Borrower = 'borrower',
  Clearinghouse = 'clearinghouse',
  ClearinghouseAddress = 'clearinghouse__address',
  ClearinghouseCollateralToken = 'clearinghouse__collateralToken',
  ClearinghouseCollateralTokenDecimals = 'clearinghouse__collateralTokenDecimals',
  ClearinghouseCoolerFactoryAddress = 'clearinghouse__coolerFactoryAddress',
  ClearinghouseCreatedBlock = 'clearinghouse__createdBlock',
  ClearinghouseCreatedTimestamp = 'clearinghouse__createdTimestamp',
  ClearinghouseDuration = 'clearinghouse__duration',
  ClearinghouseFundAmount = 'clearinghouse__fundAmount',
  ClearinghouseFundCadence = 'clearinghouse__fundCadence',
  ClearinghouseId = 'clearinghouse__id',
  ClearinghouseInterestRate = 'clearinghouse__interestRate',
  ClearinghouseLoanToCollateral = 'clearinghouse__loanToCollateral',
  ClearinghouseReserveToken = 'clearinghouse__reserveToken',
  ClearinghouseReserveTokenDecimals = 'clearinghouse__reserveTokenDecimals',
  ClearinghouseSReserveToken = 'clearinghouse__sReserveToken',
  ClearinghouseSReserveTokenDecimals = 'clearinghouse__sReserveTokenDecimals',
  ClearinghouseVersion = 'clearinghouse__version',
  CurrentBorrowed = 'currentBorrowed',
  CurrentCollateral = 'currentCollateral',
  CurrentInterestDue = 'currentInterestDue',
  Id = 'id',
  LastUpdateBlock = 'lastUpdateBlock',
  LastUpdateTimestamp = 'lastUpdateTimestamp',
  Loans = 'loans',
  MaxActiveLoans = 'maxActiveLoans',
  MaxBorrowedValue = 'maxBorrowedValue',
  TotalDefaultedLoans = 'totalDefaultedLoans',
  TotalLoanExtensions = 'totalLoanExtensions',
  TotalLoans = 'totalLoans',
  TotalRepaidLoans = 'totalRepaidLoans'
}

export type ClaimDefaultedLoanEvent = {
  __typename?: 'ClaimDefaultedLoanEvent';
  /** Block number at the time of the event. */
  blockNumber: Scalars['BigInt']['output'];
  /** Block timestamp at the time of the event. */
  blockTimestamp: Scalars['BigInt']['output'];
  /** Price of the collateral token at the time of the event. */
  collateralPrice: Scalars['BigDecimal']['output'];
  /** Collateral quantity claimed. */
  collateralQuantityClaimed: Scalars['BigDecimal']['output'];
  /** Value of the collateral claimed. */
  collateralValueClaimed: Scalars['BigDecimal']['output'];
  /** Event date in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /** Principal amount that was defaulted on */
  defaultedPrincipal: Scalars['BigDecimal']['output'];
  /**
   * Record ID.
   *
   * In the format of `cooler-loanId`.
   */
  id: Scalars['Int8']['output'];
  /** Loan that was defaulted. */
  loan: CoolerLoan;
  /** Seconds since the loan expired. */
  secondsSinceExpiry: Scalars['BigInt']['output'];
  /** Timestamp of the event. */
  timestamp: Scalars['Timestamp']['output'];
  /** Transaction hash of the event. */
  transactionHash: Scalars['Bytes']['output'];
};

export type ClaimDefaultedLoanEvent_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ClaimDefaultedLoanEvent_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralPrice_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralPrice_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralPrice_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  collateralPrice_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralPrice_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralPrice_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralPrice_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  collateralQuantityClaimed?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralQuantityClaimed_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralQuantityClaimed_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralQuantityClaimed_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  collateralQuantityClaimed_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralQuantityClaimed_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralQuantityClaimed_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralQuantityClaimed_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  collateralValueClaimed?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralValueClaimed_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralValueClaimed_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralValueClaimed_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  collateralValueClaimed_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralValueClaimed_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralValueClaimed_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateralValueClaimed_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  date_contains?: InputMaybe<Scalars['String']['input']>;
  date_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_gt?: InputMaybe<Scalars['String']['input']>;
  date_gte?: InputMaybe<Scalars['String']['input']>;
  date_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_lt?: InputMaybe<Scalars['String']['input']>;
  date_lte?: InputMaybe<Scalars['String']['input']>;
  date_not?: InputMaybe<Scalars['String']['input']>;
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  date_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  defaultedPrincipal?: InputMaybe<Scalars['BigDecimal']['input']>;
  defaultedPrincipal_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  defaultedPrincipal_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  defaultedPrincipal_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  defaultedPrincipal_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  defaultedPrincipal_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  defaultedPrincipal_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  defaultedPrincipal_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  id_not?: InputMaybe<Scalars['Int8']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<CoolerLoan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<ClaimDefaultedLoanEvent_Filter>>>;
  secondsSinceExpiry?: InputMaybe<Scalars['BigInt']['input']>;
  secondsSinceExpiry_gt?: InputMaybe<Scalars['BigInt']['input']>;
  secondsSinceExpiry_gte?: InputMaybe<Scalars['BigInt']['input']>;
  secondsSinceExpiry_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  secondsSinceExpiry_lt?: InputMaybe<Scalars['BigInt']['input']>;
  secondsSinceExpiry_lte?: InputMaybe<Scalars['BigInt']['input']>;
  secondsSinceExpiry_not?: InputMaybe<Scalars['BigInt']['input']>;
  secondsSinceExpiry_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum ClaimDefaultedLoanEvent_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  CollateralPrice = 'collateralPrice',
  CollateralQuantityClaimed = 'collateralQuantityClaimed',
  CollateralValueClaimed = 'collateralValueClaimed',
  Date = 'date',
  DefaultedPrincipal = 'defaultedPrincipal',
  Id = 'id',
  Loan = 'loan',
  LoanCollateral = 'loan__collateral',
  LoanCooler = 'loan__cooler',
  LoanCreatedBlock = 'loan__createdBlock',
  LoanCreatedTimestamp = 'loan__createdTimestamp',
  LoanCreatedTransaction = 'loan__createdTransaction',
  LoanCurrentExpiryTimestamp = 'loan__currentExpiryTimestamp',
  LoanHasCallback = 'loan__hasCallback',
  LoanId = 'loan__id',
  LoanInterest = 'loan__interest',
  LoanLoanId = 'loan__loanId',
  LoanOriginalExpiryTimestamp = 'loan__originalExpiryTimestamp',
  LoanPrincipal = 'loan__principal',
  SecondsSinceExpiry = 'secondsSinceExpiry',
  Timestamp = 'timestamp',
  TransactionHash = 'transactionHash'
}

export type ClearLoanRequestEvent = {
  __typename?: 'ClearLoanRequestEvent';
  /** Block number at the time of the event. */
  blockNumber: Scalars['BigInt']['output'];
  /** Block timestamp at the time of the event. */
  blockTimestamp: Scalars['BigInt']['output'];
  /** Event date in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /**
   * Record ID.
   *
   * In the format of `cooler-requestId`.
   */
  id: Scalars['String']['output'];
  /** The loan that was created. */
  loan: CoolerLoan;
  /** Request that created the loan. */
  request: CoolerLoanRequest;
  /** Transaction hash of the event. */
  transactionHash: Scalars['Bytes']['output'];
};

export type ClearLoanRequestEvent_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ClearLoanRequestEvent_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  date_contains?: InputMaybe<Scalars['String']['input']>;
  date_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_gt?: InputMaybe<Scalars['String']['input']>;
  date_gte?: InputMaybe<Scalars['String']['input']>;
  date_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_lt?: InputMaybe<Scalars['String']['input']>;
  date_lte?: InputMaybe<Scalars['String']['input']>;
  date_not?: InputMaybe<Scalars['String']['input']>;
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  date_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<CoolerLoan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<ClearLoanRequestEvent_Filter>>>;
  request?: InputMaybe<Scalars['String']['input']>;
  request_?: InputMaybe<CoolerLoanRequest_Filter>;
  request_contains?: InputMaybe<Scalars['String']['input']>;
  request_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  request_ends_with?: InputMaybe<Scalars['String']['input']>;
  request_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  request_gt?: InputMaybe<Scalars['String']['input']>;
  request_gte?: InputMaybe<Scalars['String']['input']>;
  request_in?: InputMaybe<Array<Scalars['String']['input']>>;
  request_lt?: InputMaybe<Scalars['String']['input']>;
  request_lte?: InputMaybe<Scalars['String']['input']>;
  request_not?: InputMaybe<Scalars['String']['input']>;
  request_not_contains?: InputMaybe<Scalars['String']['input']>;
  request_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  request_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  request_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  request_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  request_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  request_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  request_starts_with?: InputMaybe<Scalars['String']['input']>;
  request_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum ClearLoanRequestEvent_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Date = 'date',
  Id = 'id',
  Loan = 'loan',
  LoanCollateral = 'loan__collateral',
  LoanCooler = 'loan__cooler',
  LoanCreatedBlock = 'loan__createdBlock',
  LoanCreatedTimestamp = 'loan__createdTimestamp',
  LoanCreatedTransaction = 'loan__createdTransaction',
  LoanCurrentExpiryTimestamp = 'loan__currentExpiryTimestamp',
  LoanHasCallback = 'loan__hasCallback',
  LoanId = 'loan__id',
  LoanInterest = 'loan__interest',
  LoanLoanId = 'loan__loanId',
  LoanOriginalExpiryTimestamp = 'loan__originalExpiryTimestamp',
  LoanPrincipal = 'loan__principal',
  Request = 'request',
  RequestAmount = 'request__amount',
  RequestBorrower = 'request__borrower',
  RequestCollateralToken = 'request__collateralToken',
  RequestCooler = 'request__cooler',
  RequestCreatedBlock = 'request__createdBlock',
  RequestCreatedTimestamp = 'request__createdTimestamp',
  RequestCreatedTransaction = 'request__createdTransaction',
  RequestDebtToken = 'request__debtToken',
  RequestDurationSeconds = 'request__durationSeconds',
  RequestId = 'request__id',
  RequestInterestPercentage = 'request__interestPercentage',
  RequestIsRescinded = 'request__isRescinded',
  RequestLoanToCollateralRatio = 'request__loanToCollateralRatio',
  RequestRequestId = 'request__requestId',
  TransactionHash = 'transactionHash'
}

export type Clearinghouse = {
  __typename?: 'Clearinghouse';
  /** Address of the Clearinghouse. */
  address: Scalars['Bytes']['output'];
  /** Address of the collateral token. */
  collateralToken: Scalars['Bytes']['output'];
  /** Number of decimals of the collateral token. */
  collateralTokenDecimals: Scalars['Int']['output'];
  /** Address of the CoolerFactory. */
  coolerFactoryAddress: Scalars['Bytes']['output'];
  /** Block number at the time of the creation of the record. */
  createdBlock: Scalars['BigInt']['output'];
  /** Timestamp at the time of the creation of the record. */
  createdTimestamp: Scalars['BigInt']['output'];
  /** Duration of loans in seconds. */
  duration: Scalars['BigInt']['output'];
  /** Amount of reserves required to be in the Clearinghouse. */
  fundAmount: Scalars['BigDecimal']['output'];
  /** Frequency of rebalances in seconds. */
  fundCadence: Scalars['BigInt']['output'];
  /**
   * Record ID.
   *
   * In the format of `address`.
   */
  id: Scalars['String']['output'];
  /**
   * Annual interest rate.
   *
   * In the format of 0.1 = 10%.
   */
  interestRate: Scalars['BigDecimal']['output'];
  /** Ratio of the quantity of debt token to 1 collateral token, e.g. 3000 reserve/gOHM */
  loanToCollateral: Scalars['BigDecimal']['output'];
  loans: Array<CoolerLoan>;
  /** Address of the reserve (and debt) token. */
  reserveToken: Scalars['Bytes']['output'];
  /** Number of decimals of the reserve token. */
  reserveTokenDecimals: Scalars['Int']['output'];
  /** Address of the sReserve token. */
  sReserveToken: Scalars['Bytes']['output'];
  /** Number of decimals of the sReserve token. */
  sReserveTokenDecimals: Scalars['Int']['output'];
  /** ClearinghouseSingleton allows all Clearinghouses to be linked to the same record. */
  singleton: ClearinghouseSingleton;
  snapshots: Array<ClearinghouseSnapshot>;
  /** Version of the Clearinghouse. */
  version: Scalars['String']['output'];
};


export type ClearinghouseLoansArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CoolerLoan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CoolerLoan_Filter>;
};


export type ClearinghouseSnapshotsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClearinghouseSnapshot_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ClearinghouseSnapshot_Filter>;
};

/** Tracks cumulative stats for a clearinghouse */
export type ClearinghouseCumulativeStats = {
  __typename?: 'ClearinghouseCumulativeStats';
  /** The clearinghouse this tracks stats for */
  clearinghouse: Clearinghouse;
  /** Current number of active borrowers */
  currentActiveBorrowers: Scalars['Int']['output'];
  /** Current number of active loans */
  currentActiveLoans: Scalars['Int']['output'];
  /** Current number of active borrowers with multiple loans */
  currentActiveLoopers: Scalars['Int']['output'];
  /** Record ID - the clearinghouse address */
  id: Scalars['String']['output'];
  /** Last updated block number */
  lastUpdateBlock: Scalars['BigInt']['output'];
  /** Last updated timestamp */
  lastUpdateTimestamp: Scalars['BigInt']['output'];
  /** Total number of defaulted loans */
  totalDefaultedLoans: Scalars['Int']['output'];
  /** Total number of loan extensions */
  totalLoanExtensions: Scalars['Int']['output'];
  /** Total number of loans ever created */
  totalLoans: Scalars['Int']['output'];
  /** Total number of borrowers who have taken multiple loans */
  totalLoopers: Scalars['Int']['output'];
  /** Total number of repaid loans */
  totalRepaidLoans: Scalars['Int']['output'];
  /** Total number of unique borrowers ever */
  totalUniqueBorrowers: Scalars['Int']['output'];
};

export type ClearinghouseCumulativeStats_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ClearinghouseCumulativeStats_Filter>>>;
  clearinghouse?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_?: InputMaybe<Clearinghouse_Filter>;
  clearinghouse_contains?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_ends_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_gt?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_gte?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clearinghouse_lt?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_lte?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_contains?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clearinghouse_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_starts_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentActiveBorrowers?: InputMaybe<Scalars['Int']['input']>;
  currentActiveBorrowers_gt?: InputMaybe<Scalars['Int']['input']>;
  currentActiveBorrowers_gte?: InputMaybe<Scalars['Int']['input']>;
  currentActiveBorrowers_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentActiveBorrowers_lt?: InputMaybe<Scalars['Int']['input']>;
  currentActiveBorrowers_lte?: InputMaybe<Scalars['Int']['input']>;
  currentActiveBorrowers_not?: InputMaybe<Scalars['Int']['input']>;
  currentActiveBorrowers_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentActiveLoans?: InputMaybe<Scalars['Int']['input']>;
  currentActiveLoans_gt?: InputMaybe<Scalars['Int']['input']>;
  currentActiveLoans_gte?: InputMaybe<Scalars['Int']['input']>;
  currentActiveLoans_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentActiveLoans_lt?: InputMaybe<Scalars['Int']['input']>;
  currentActiveLoans_lte?: InputMaybe<Scalars['Int']['input']>;
  currentActiveLoans_not?: InputMaybe<Scalars['Int']['input']>;
  currentActiveLoans_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentActiveLoopers?: InputMaybe<Scalars['Int']['input']>;
  currentActiveLoopers_gt?: InputMaybe<Scalars['Int']['input']>;
  currentActiveLoopers_gte?: InputMaybe<Scalars['Int']['input']>;
  currentActiveLoopers_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentActiveLoopers_lt?: InputMaybe<Scalars['Int']['input']>;
  currentActiveLoopers_lte?: InputMaybe<Scalars['Int']['input']>;
  currentActiveLoopers_not?: InputMaybe<Scalars['Int']['input']>;
  currentActiveLoopers_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lastUpdateBlock?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastUpdateBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateBlock_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastUpdateTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastUpdateTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ClearinghouseCumulativeStats_Filter>>>;
  totalDefaultedLoans?: InputMaybe<Scalars['Int']['input']>;
  totalDefaultedLoans_gt?: InputMaybe<Scalars['Int']['input']>;
  totalDefaultedLoans_gte?: InputMaybe<Scalars['Int']['input']>;
  totalDefaultedLoans_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalDefaultedLoans_lt?: InputMaybe<Scalars['Int']['input']>;
  totalDefaultedLoans_lte?: InputMaybe<Scalars['Int']['input']>;
  totalDefaultedLoans_not?: InputMaybe<Scalars['Int']['input']>;
  totalDefaultedLoans_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLoanExtensions?: InputMaybe<Scalars['Int']['input']>;
  totalLoanExtensions_gt?: InputMaybe<Scalars['Int']['input']>;
  totalLoanExtensions_gte?: InputMaybe<Scalars['Int']['input']>;
  totalLoanExtensions_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLoanExtensions_lt?: InputMaybe<Scalars['Int']['input']>;
  totalLoanExtensions_lte?: InputMaybe<Scalars['Int']['input']>;
  totalLoanExtensions_not?: InputMaybe<Scalars['Int']['input']>;
  totalLoanExtensions_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLoans?: InputMaybe<Scalars['Int']['input']>;
  totalLoans_gt?: InputMaybe<Scalars['Int']['input']>;
  totalLoans_gte?: InputMaybe<Scalars['Int']['input']>;
  totalLoans_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLoans_lt?: InputMaybe<Scalars['Int']['input']>;
  totalLoans_lte?: InputMaybe<Scalars['Int']['input']>;
  totalLoans_not?: InputMaybe<Scalars['Int']['input']>;
  totalLoans_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLoopers?: InputMaybe<Scalars['Int']['input']>;
  totalLoopers_gt?: InputMaybe<Scalars['Int']['input']>;
  totalLoopers_gte?: InputMaybe<Scalars['Int']['input']>;
  totalLoopers_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLoopers_lt?: InputMaybe<Scalars['Int']['input']>;
  totalLoopers_lte?: InputMaybe<Scalars['Int']['input']>;
  totalLoopers_not?: InputMaybe<Scalars['Int']['input']>;
  totalLoopers_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalRepaidLoans?: InputMaybe<Scalars['Int']['input']>;
  totalRepaidLoans_gt?: InputMaybe<Scalars['Int']['input']>;
  totalRepaidLoans_gte?: InputMaybe<Scalars['Int']['input']>;
  totalRepaidLoans_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalRepaidLoans_lt?: InputMaybe<Scalars['Int']['input']>;
  totalRepaidLoans_lte?: InputMaybe<Scalars['Int']['input']>;
  totalRepaidLoans_not?: InputMaybe<Scalars['Int']['input']>;
  totalRepaidLoans_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalUniqueBorrowers?: InputMaybe<Scalars['Int']['input']>;
  totalUniqueBorrowers_gt?: InputMaybe<Scalars['Int']['input']>;
  totalUniqueBorrowers_gte?: InputMaybe<Scalars['Int']['input']>;
  totalUniqueBorrowers_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalUniqueBorrowers_lt?: InputMaybe<Scalars['Int']['input']>;
  totalUniqueBorrowers_lte?: InputMaybe<Scalars['Int']['input']>;
  totalUniqueBorrowers_not?: InputMaybe<Scalars['Int']['input']>;
  totalUniqueBorrowers_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum ClearinghouseCumulativeStats_OrderBy {
  Clearinghouse = 'clearinghouse',
  ClearinghouseAddress = 'clearinghouse__address',
  ClearinghouseCollateralToken = 'clearinghouse__collateralToken',
  ClearinghouseCollateralTokenDecimals = 'clearinghouse__collateralTokenDecimals',
  ClearinghouseCoolerFactoryAddress = 'clearinghouse__coolerFactoryAddress',
  ClearinghouseCreatedBlock = 'clearinghouse__createdBlock',
  ClearinghouseCreatedTimestamp = 'clearinghouse__createdTimestamp',
  ClearinghouseDuration = 'clearinghouse__duration',
  ClearinghouseFundAmount = 'clearinghouse__fundAmount',
  ClearinghouseFundCadence = 'clearinghouse__fundCadence',
  ClearinghouseId = 'clearinghouse__id',
  ClearinghouseInterestRate = 'clearinghouse__interestRate',
  ClearinghouseLoanToCollateral = 'clearinghouse__loanToCollateral',
  ClearinghouseReserveToken = 'clearinghouse__reserveToken',
  ClearinghouseReserveTokenDecimals = 'clearinghouse__reserveTokenDecimals',
  ClearinghouseSReserveToken = 'clearinghouse__sReserveToken',
  ClearinghouseSReserveTokenDecimals = 'clearinghouse__sReserveTokenDecimals',
  ClearinghouseVersion = 'clearinghouse__version',
  CurrentActiveBorrowers = 'currentActiveBorrowers',
  CurrentActiveLoans = 'currentActiveLoans',
  CurrentActiveLoopers = 'currentActiveLoopers',
  Id = 'id',
  LastUpdateBlock = 'lastUpdateBlock',
  LastUpdateTimestamp = 'lastUpdateTimestamp',
  TotalDefaultedLoans = 'totalDefaultedLoans',
  TotalLoanExtensions = 'totalLoanExtensions',
  TotalLoans = 'totalLoans',
  TotalLoopers = 'totalLoopers',
  TotalRepaidLoans = 'totalRepaidLoans',
  TotalUniqueBorrowers = 'totalUniqueBorrowers'
}

export type ClearinghouseSingleton = {
  __typename?: 'ClearinghouseSingleton';
  clearinghouses: Array<Clearinghouse>;
  /** Record ID. */
  id: Scalars['String']['output'];
};


export type ClearinghouseSingletonClearinghousesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Clearinghouse_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Clearinghouse_Filter>;
};

export type ClearinghouseSingleton_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ClearinghouseSingleton_Filter>>>;
  clearinghouses_?: InputMaybe<Clearinghouse_Filter>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<ClearinghouseSingleton_Filter>>>;
};

export enum ClearinghouseSingleton_OrderBy {
  Clearinghouses = 'clearinghouses',
  Id = 'id'
}

export type ClearinghouseSnapshot = {
  __typename?: 'ClearinghouseSnapshot';
  /** Block number at the time of the event. */
  blockNumber: Scalars['BigInt']['output'];
  /** Block timestamp at the time of the event. */
  blockTimestamp: Scalars['BigInt']['output'];
  /** The Clearinghouse that the snapshot is for. */
  clearinghouse: Clearinghouse;
  /** Snapshot date in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /** The id of the snapshot. */
  id: Scalars['Int8']['output'];
  /** Total interest receivables. */
  interestReceivables: Scalars['BigDecimal']['output'];
  /** Whether the Clearinghouse is active. */
  isActive: Scalars['Boolean']['output'];
  /** Timestamp of the next rebalance. */
  nextRebalanceTimestamp: Scalars['BigInt']['output'];
  /** Total principal receivables. */
  principalReceivables: Scalars['BigDecimal']['output'];
  /** Reserve balance of the clearinghouse. */
  reserveBalance: Scalars['BigDecimal']['output'];
  /** Address of the reserve token. */
  reserveToken: Scalars['Bytes']['output'];
  /** sReserve balance of the clearinghouse. */
  sReserveBalance: Scalars['BigDecimal']['output'];
  /** sReserve balance of the clearinghouse, in terms of reserve tokens. */
  sReserveInReserveBalance: Scalars['BigDecimal']['output'];
  /** Address of the sReserve token. */
  sReserveToken: Scalars['Bytes']['output'];
  /** Timestamp of the snapshot. */
  timestamp: Scalars['Timestamp']['output'];
  /** Transaction hash of the event. */
  transactionHash: Scalars['Bytes']['output'];
  /** Reserve balance of the treasury. */
  treasuryReserveBalance: Scalars['BigDecimal']['output'];
  /** sReserve balance of the treasury. */
  treasurySReserveBalance: Scalars['BigDecimal']['output'];
  /** sReserve balance of the treasury, in terms of reserve tokens. */
  treasurySReserveInReserveBalance: Scalars['BigDecimal']['output'];
};

/** Daily stats for the Clearinghouse */
export type ClearinghouseSnapshotStats = {
  __typename?: 'ClearinghouseSnapshotStats';
  clearinghouse: Clearinghouse;
  id: Scalars['Int8']['output'];
  reserveBalance: Scalars['BigDecimal']['output'];
  sReserveBalance: Scalars['BigDecimal']['output'];
  sReserveInReserveBalance: Scalars['BigDecimal']['output'];
  snapshotCount: Scalars['Int']['output'];
  timestamp: Scalars['Timestamp']['output'];
  totalInterestReceivables: Scalars['BigDecimal']['output'];
  totalPrincipalReceivables: Scalars['BigDecimal']['output'];
  treasuryReserveBalance: Scalars['BigDecimal']['output'];
  treasurySReserveBalance: Scalars['BigDecimal']['output'];
  treasurySReserveInReserveBalance: Scalars['BigDecimal']['output'];
};

export type ClearinghouseSnapshotStats_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ClearinghouseSnapshotStats_Filter>>>;
  clearinghouse?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_?: InputMaybe<Clearinghouse_Filter>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  or?: InputMaybe<Array<InputMaybe<ClearinghouseSnapshotStats_Filter>>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum ClearinghouseSnapshotStats_OrderBy {
  Clearinghouse = 'clearinghouse',
  ClearinghouseAddress = 'clearinghouse__address',
  ClearinghouseCollateralToken = 'clearinghouse__collateralToken',
  ClearinghouseCollateralTokenDecimals = 'clearinghouse__collateralTokenDecimals',
  ClearinghouseCoolerFactoryAddress = 'clearinghouse__coolerFactoryAddress',
  ClearinghouseCreatedBlock = 'clearinghouse__createdBlock',
  ClearinghouseCreatedTimestamp = 'clearinghouse__createdTimestamp',
  ClearinghouseDuration = 'clearinghouse__duration',
  ClearinghouseFundAmount = 'clearinghouse__fundAmount',
  ClearinghouseFundCadence = 'clearinghouse__fundCadence',
  ClearinghouseId = 'clearinghouse__id',
  ClearinghouseInterestRate = 'clearinghouse__interestRate',
  ClearinghouseLoanToCollateral = 'clearinghouse__loanToCollateral',
  ClearinghouseReserveToken = 'clearinghouse__reserveToken',
  ClearinghouseReserveTokenDecimals = 'clearinghouse__reserveTokenDecimals',
  ClearinghouseSReserveToken = 'clearinghouse__sReserveToken',
  ClearinghouseSReserveTokenDecimals = 'clearinghouse__sReserveTokenDecimals',
  ClearinghouseVersion = 'clearinghouse__version',
  Id = 'id',
  ReserveBalance = 'reserveBalance',
  SReserveBalance = 'sReserveBalance',
  SReserveInReserveBalance = 'sReserveInReserveBalance',
  SnapshotCount = 'snapshotCount',
  Timestamp = 'timestamp',
  TotalInterestReceivables = 'totalInterestReceivables',
  TotalPrincipalReceivables = 'totalPrincipalReceivables',
  TreasuryReserveBalance = 'treasuryReserveBalance',
  TreasurySReserveBalance = 'treasurySReserveBalance',
  TreasurySReserveInReserveBalance = 'treasurySReserveInReserveBalance'
}

export type ClearinghouseSnapshot_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ClearinghouseSnapshot_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  clearinghouse?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_?: InputMaybe<Clearinghouse_Filter>;
  clearinghouse_contains?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_ends_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_gt?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_gte?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clearinghouse_lt?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_lte?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_contains?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clearinghouse_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_starts_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  date_contains?: InputMaybe<Scalars['String']['input']>;
  date_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_gt?: InputMaybe<Scalars['String']['input']>;
  date_gte?: InputMaybe<Scalars['String']['input']>;
  date_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_lt?: InputMaybe<Scalars['String']['input']>;
  date_lte?: InputMaybe<Scalars['String']['input']>;
  date_not?: InputMaybe<Scalars['String']['input']>;
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  date_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  id_not?: InputMaybe<Scalars['Int8']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  interestReceivables?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestReceivables_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestReceivables_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestReceivables_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  interestReceivables_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestReceivables_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestReceivables_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestReceivables_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActive_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isActive_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  nextRebalanceTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  nextRebalanceTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  nextRebalanceTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  nextRebalanceTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextRebalanceTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  nextRebalanceTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  nextRebalanceTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  nextRebalanceTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<ClearinghouseSnapshot_Filter>>>;
  principalReceivables?: InputMaybe<Scalars['BigDecimal']['input']>;
  principalReceivables_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  principalReceivables_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  principalReceivables_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  principalReceivables_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  principalReceivables_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  principalReceivables_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  principalReceivables_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  reserveBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  reserveBalance_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  reserveBalance_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  reserveBalance_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  reserveBalance_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  reserveBalance_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  reserveBalance_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  reserveBalance_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  reserveToken?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_contains?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_gt?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_gte?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  reserveToken_lt?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_lte?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_not?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  sReserveBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  sReserveBalance_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  sReserveBalance_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  sReserveBalance_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  sReserveBalance_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  sReserveBalance_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  sReserveBalance_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  sReserveBalance_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  sReserveInReserveBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  sReserveInReserveBalance_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  sReserveInReserveBalance_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  sReserveInReserveBalance_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  sReserveInReserveBalance_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  sReserveInReserveBalance_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  sReserveInReserveBalance_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  sReserveInReserveBalance_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  sReserveToken?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_contains?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_gt?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_gte?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  sReserveToken_lt?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_lte?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_not?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  treasuryReserveBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasuryReserveBalance_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasuryReserveBalance_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasuryReserveBalance_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  treasuryReserveBalance_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasuryReserveBalance_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasuryReserveBalance_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasuryReserveBalance_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  treasurySReserveBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasurySReserveBalance_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasurySReserveBalance_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasurySReserveBalance_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  treasurySReserveBalance_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasurySReserveBalance_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasurySReserveBalance_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasurySReserveBalance_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  treasurySReserveInReserveBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasurySReserveInReserveBalance_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasurySReserveInReserveBalance_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasurySReserveInReserveBalance_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  treasurySReserveInReserveBalance_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasurySReserveInReserveBalance_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasurySReserveInReserveBalance_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  treasurySReserveInReserveBalance_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum ClearinghouseSnapshot_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Clearinghouse = 'clearinghouse',
  ClearinghouseAddress = 'clearinghouse__address',
  ClearinghouseCollateralToken = 'clearinghouse__collateralToken',
  ClearinghouseCollateralTokenDecimals = 'clearinghouse__collateralTokenDecimals',
  ClearinghouseCoolerFactoryAddress = 'clearinghouse__coolerFactoryAddress',
  ClearinghouseCreatedBlock = 'clearinghouse__createdBlock',
  ClearinghouseCreatedTimestamp = 'clearinghouse__createdTimestamp',
  ClearinghouseDuration = 'clearinghouse__duration',
  ClearinghouseFundAmount = 'clearinghouse__fundAmount',
  ClearinghouseFundCadence = 'clearinghouse__fundCadence',
  ClearinghouseId = 'clearinghouse__id',
  ClearinghouseInterestRate = 'clearinghouse__interestRate',
  ClearinghouseLoanToCollateral = 'clearinghouse__loanToCollateral',
  ClearinghouseReserveToken = 'clearinghouse__reserveToken',
  ClearinghouseReserveTokenDecimals = 'clearinghouse__reserveTokenDecimals',
  ClearinghouseSReserveToken = 'clearinghouse__sReserveToken',
  ClearinghouseSReserveTokenDecimals = 'clearinghouse__sReserveTokenDecimals',
  ClearinghouseVersion = 'clearinghouse__version',
  Date = 'date',
  Id = 'id',
  InterestReceivables = 'interestReceivables',
  IsActive = 'isActive',
  NextRebalanceTimestamp = 'nextRebalanceTimestamp',
  PrincipalReceivables = 'principalReceivables',
  ReserveBalance = 'reserveBalance',
  ReserveToken = 'reserveToken',
  SReserveBalance = 'sReserveBalance',
  SReserveInReserveBalance = 'sReserveInReserveBalance',
  SReserveToken = 'sReserveToken',
  Timestamp = 'timestamp',
  TransactionHash = 'transactionHash',
  TreasuryReserveBalance = 'treasuryReserveBalance',
  TreasurySReserveBalance = 'treasurySReserveBalance',
  TreasurySReserveInReserveBalance = 'treasurySReserveInReserveBalance'
}

export type Clearinghouse_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  address?: InputMaybe<Scalars['Bytes']['input']>;
  address_contains?: InputMaybe<Scalars['Bytes']['input']>;
  address_gt?: InputMaybe<Scalars['Bytes']['input']>;
  address_gte?: InputMaybe<Scalars['Bytes']['input']>;
  address_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  address_lt?: InputMaybe<Scalars['Bytes']['input']>;
  address_lte?: InputMaybe<Scalars['Bytes']['input']>;
  address_not?: InputMaybe<Scalars['Bytes']['input']>;
  address_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  address_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  and?: InputMaybe<Array<InputMaybe<Clearinghouse_Filter>>>;
  collateralToken?: InputMaybe<Scalars['Bytes']['input']>;
  collateralTokenDecimals?: InputMaybe<Scalars['Int']['input']>;
  collateralTokenDecimals_gt?: InputMaybe<Scalars['Int']['input']>;
  collateralTokenDecimals_gte?: InputMaybe<Scalars['Int']['input']>;
  collateralTokenDecimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  collateralTokenDecimals_lt?: InputMaybe<Scalars['Int']['input']>;
  collateralTokenDecimals_lte?: InputMaybe<Scalars['Int']['input']>;
  collateralTokenDecimals_not?: InputMaybe<Scalars['Int']['input']>;
  collateralTokenDecimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  collateralToken_contains?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_gt?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_gte?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  collateralToken_lt?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_lte?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_not?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  coolerFactoryAddress?: InputMaybe<Scalars['Bytes']['input']>;
  coolerFactoryAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  coolerFactoryAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  coolerFactoryAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  coolerFactoryAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  coolerFactoryAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  coolerFactoryAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  coolerFactoryAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  coolerFactoryAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  coolerFactoryAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  createdBlock?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  duration?: InputMaybe<Scalars['BigInt']['input']>;
  duration_gt?: InputMaybe<Scalars['BigInt']['input']>;
  duration_gte?: InputMaybe<Scalars['BigInt']['input']>;
  duration_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  duration_lt?: InputMaybe<Scalars['BigInt']['input']>;
  duration_lte?: InputMaybe<Scalars['BigInt']['input']>;
  duration_not?: InputMaybe<Scalars['BigInt']['input']>;
  duration_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  fundAmount_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  fundAmount_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  fundAmount_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  fundAmount_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  fundAmount_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  fundAmount_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  fundAmount_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  fundCadence?: InputMaybe<Scalars['BigInt']['input']>;
  fundCadence_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fundCadence_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fundCadence_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundCadence_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fundCadence_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fundCadence_not?: InputMaybe<Scalars['BigInt']['input']>;
  fundCadence_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  interestRate?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestRate_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestRate_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestRate_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  interestRate_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestRate_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestRate_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestRate_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  loanToCollateral?: InputMaybe<Scalars['BigDecimal']['input']>;
  loanToCollateral_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  loanToCollateral_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  loanToCollateral_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  loanToCollateral_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  loanToCollateral_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  loanToCollateral_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  loanToCollateral_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  loans_?: InputMaybe<CoolerLoan_Filter>;
  or?: InputMaybe<Array<InputMaybe<Clearinghouse_Filter>>>;
  reserveToken?: InputMaybe<Scalars['Bytes']['input']>;
  reserveTokenDecimals?: InputMaybe<Scalars['Int']['input']>;
  reserveTokenDecimals_gt?: InputMaybe<Scalars['Int']['input']>;
  reserveTokenDecimals_gte?: InputMaybe<Scalars['Int']['input']>;
  reserveTokenDecimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  reserveTokenDecimals_lt?: InputMaybe<Scalars['Int']['input']>;
  reserveTokenDecimals_lte?: InputMaybe<Scalars['Int']['input']>;
  reserveTokenDecimals_not?: InputMaybe<Scalars['Int']['input']>;
  reserveTokenDecimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  reserveToken_contains?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_gt?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_gte?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  reserveToken_lt?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_lte?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_not?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  reserveToken_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  sReserveToken?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveTokenDecimals?: InputMaybe<Scalars['Int']['input']>;
  sReserveTokenDecimals_gt?: InputMaybe<Scalars['Int']['input']>;
  sReserveTokenDecimals_gte?: InputMaybe<Scalars['Int']['input']>;
  sReserveTokenDecimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  sReserveTokenDecimals_lt?: InputMaybe<Scalars['Int']['input']>;
  sReserveTokenDecimals_lte?: InputMaybe<Scalars['Int']['input']>;
  sReserveTokenDecimals_not?: InputMaybe<Scalars['Int']['input']>;
  sReserveTokenDecimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  sReserveToken_contains?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_gt?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_gte?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  sReserveToken_lt?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_lte?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_not?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  sReserveToken_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  singleton?: InputMaybe<Scalars['String']['input']>;
  singleton_?: InputMaybe<ClearinghouseSingleton_Filter>;
  singleton_contains?: InputMaybe<Scalars['String']['input']>;
  singleton_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  singleton_ends_with?: InputMaybe<Scalars['String']['input']>;
  singleton_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  singleton_gt?: InputMaybe<Scalars['String']['input']>;
  singleton_gte?: InputMaybe<Scalars['String']['input']>;
  singleton_in?: InputMaybe<Array<Scalars['String']['input']>>;
  singleton_lt?: InputMaybe<Scalars['String']['input']>;
  singleton_lte?: InputMaybe<Scalars['String']['input']>;
  singleton_not?: InputMaybe<Scalars['String']['input']>;
  singleton_not_contains?: InputMaybe<Scalars['String']['input']>;
  singleton_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  singleton_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  singleton_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  singleton_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  singleton_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  singleton_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  singleton_starts_with?: InputMaybe<Scalars['String']['input']>;
  singleton_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  snapshots_?: InputMaybe<ClearinghouseSnapshot_Filter>;
  version?: InputMaybe<Scalars['String']['input']>;
  version_contains?: InputMaybe<Scalars['String']['input']>;
  version_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  version_ends_with?: InputMaybe<Scalars['String']['input']>;
  version_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  version_gt?: InputMaybe<Scalars['String']['input']>;
  version_gte?: InputMaybe<Scalars['String']['input']>;
  version_in?: InputMaybe<Array<Scalars['String']['input']>>;
  version_lt?: InputMaybe<Scalars['String']['input']>;
  version_lte?: InputMaybe<Scalars['String']['input']>;
  version_not?: InputMaybe<Scalars['String']['input']>;
  version_not_contains?: InputMaybe<Scalars['String']['input']>;
  version_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  version_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  version_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  version_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  version_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  version_starts_with?: InputMaybe<Scalars['String']['input']>;
  version_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Clearinghouse_OrderBy {
  Address = 'address',
  CollateralToken = 'collateralToken',
  CollateralTokenDecimals = 'collateralTokenDecimals',
  CoolerFactoryAddress = 'coolerFactoryAddress',
  CreatedBlock = 'createdBlock',
  CreatedTimestamp = 'createdTimestamp',
  Duration = 'duration',
  FundAmount = 'fundAmount',
  FundCadence = 'fundCadence',
  Id = 'id',
  InterestRate = 'interestRate',
  LoanToCollateral = 'loanToCollateral',
  Loans = 'loans',
  ReserveToken = 'reserveToken',
  ReserveTokenDecimals = 'reserveTokenDecimals',
  SReserveToken = 'sReserveToken',
  SReserveTokenDecimals = 'sReserveTokenDecimals',
  Singleton = 'singleton',
  SingletonId = 'singleton__id',
  Snapshots = 'snapshots',
  Version = 'version'
}

export type CoolerLoan = {
  __typename?: 'CoolerLoan';
  /** Address of the borrower. */
  borrower: BorrowerStats;
  /** The Clearinghouse that created the loan. */
  clearinghouse: Clearinghouse;
  /** Collateral held. */
  collateral: Scalars['BigDecimal']['output'];
  /** Address of the Cooler. */
  cooler: Scalars['Bytes']['output'];
  /** Block number at the time of the loan. */
  createdBlock: Scalars['BigInt']['output'];
  /** Timestamp at the time of the loan. */
  createdTimestamp: Scalars['BigInt']['output'];
  /** Transaction hash of the loan. */
  createdTransaction: Scalars['Bytes']['output'];
  creationEvents: Array<ClearLoanRequestEvent>;
  /** Expiry timestamp. */
  currentExpiryTimestamp: Scalars['BigInt']['output'];
  defaultedClaimEvents: Array<ClaimDefaultedLoanEvent>;
  extendEvents: Array<ExtendLoanEvent>;
  /** Whether the loan has a callback. */
  hasCallback: Scalars['Boolean']['output'];
  /**
   * Record ID.
   *
   * In the format of `cooler-loanId`.
   */
  id: Scalars['String']['output'];
  /** Interest to be paid. */
  interest: Scalars['BigDecimal']['output'];
  /**
   * Loan ID.
   *
   * The ID is unique to the Cooler.
   */
  loanId: Scalars['BigInt']['output'];
  /** Expiry timestamp. */
  originalExpiryTimestamp: Scalars['BigInt']['output'];
  /** Principal to be paid. */
  principal: Scalars['BigDecimal']['output'];
  repaymentEvents: Array<RepayLoanEvent>;
  /** Request that created this loan. */
  request: CoolerLoanRequest;
};


export type CoolerLoanCreationEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClearLoanRequestEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ClearLoanRequestEvent_Filter>;
};


export type CoolerLoanDefaultedClaimEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClaimDefaultedLoanEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ClaimDefaultedLoanEvent_Filter>;
};


export type CoolerLoanExtendEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExtendLoanEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExtendLoanEvent_Filter>;
};


export type CoolerLoanRepaymentEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepayLoanEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RepayLoanEvent_Filter>;
};

export type CoolerLoanRequest = {
  __typename?: 'CoolerLoanRequest';
  /** Amount to be borrowed. */
  amount: Scalars['BigDecimal']['output'];
  /** Address of the borrower. */
  borrower: Scalars['Bytes']['output'];
  clearEvents: Array<ClearLoanRequestEvent>;
  /** Address of the collateral token. */
  collateralToken: Scalars['Bytes']['output'];
  /** Address of the Cooler. */
  cooler: Scalars['Bytes']['output'];
  /** Block number at the time of the request. */
  createdBlock: Scalars['BigInt']['output'];
  /** Timestamp at the time of the request. */
  createdTimestamp: Scalars['BigInt']['output'];
  /** Transaction hash of the request. */
  createdTransaction: Scalars['Bytes']['output'];
  /** Address of the debt token. */
  debtToken: Scalars['Bytes']['output'];
  /** Duration of the loan in seconds. */
  durationSeconds: Scalars['BigInt']['output'];
  /**
   * Record ID.
   *
   * In the format of `cooler-requestId`.
   */
  id: Scalars['String']['output'];
  /** Annualized percentage to be paid as interest. Represented as a decimal, e.g. 0.1 = 10% */
  interestPercentage: Scalars['BigDecimal']['output'];
  /** Whether the request has been rescinded. */
  isRescinded: Scalars['Boolean']['output'];
  /** Ratio of the quantity of debt token to 1 collateral token, e.g. 3000 DAI/gOHM */
  loanToCollateralRatio: Scalars['BigDecimal']['output'];
  loans: Array<CoolerLoan>;
  requestEvents: Array<RequestLoanEvent>;
  /** Request id. */
  requestId: Scalars['BigInt']['output'];
  rescindEvents: Array<RescindLoanRequestEvent>;
};


export type CoolerLoanRequestClearEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClearLoanRequestEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ClearLoanRequestEvent_Filter>;
};


export type CoolerLoanRequestLoansArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CoolerLoan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CoolerLoan_Filter>;
};


export type CoolerLoanRequestRequestEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RequestLoanEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RequestLoanEvent_Filter>;
};


export type CoolerLoanRequestRescindEventsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RescindLoanRequestEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RescindLoanRequestEvent_Filter>;
};

export type CoolerLoanRequest_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  and?: InputMaybe<Array<InputMaybe<CoolerLoanRequest_Filter>>>;
  borrower?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_contains?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_gt?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_gte?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  borrower_lt?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_lte?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_not?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  borrower_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  clearEvents_?: InputMaybe<ClearLoanRequestEvent_Filter>;
  collateralToken?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_contains?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_gt?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_gte?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  collateralToken_lt?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_lte?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_not?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  collateralToken_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  cooler?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_contains?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_gt?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_gte?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  cooler_lt?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_lte?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_not?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  createdBlock?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdTransaction?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_contains?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_gt?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_gte?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  createdTransaction_lt?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_lte?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_not?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  debtToken?: InputMaybe<Scalars['Bytes']['input']>;
  debtToken_contains?: InputMaybe<Scalars['Bytes']['input']>;
  debtToken_gt?: InputMaybe<Scalars['Bytes']['input']>;
  debtToken_gte?: InputMaybe<Scalars['Bytes']['input']>;
  debtToken_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  debtToken_lt?: InputMaybe<Scalars['Bytes']['input']>;
  debtToken_lte?: InputMaybe<Scalars['Bytes']['input']>;
  debtToken_not?: InputMaybe<Scalars['Bytes']['input']>;
  debtToken_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  debtToken_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  durationSeconds?: InputMaybe<Scalars['BigInt']['input']>;
  durationSeconds_gt?: InputMaybe<Scalars['BigInt']['input']>;
  durationSeconds_gte?: InputMaybe<Scalars['BigInt']['input']>;
  durationSeconds_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  durationSeconds_lt?: InputMaybe<Scalars['BigInt']['input']>;
  durationSeconds_lte?: InputMaybe<Scalars['BigInt']['input']>;
  durationSeconds_not?: InputMaybe<Scalars['BigInt']['input']>;
  durationSeconds_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  interestPercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestPercentage_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestPercentage_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestPercentage_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  interestPercentage_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestPercentage_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestPercentage_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestPercentage_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  isRescinded?: InputMaybe<Scalars['Boolean']['input']>;
  isRescinded_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isRescinded_not?: InputMaybe<Scalars['Boolean']['input']>;
  isRescinded_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  loanToCollateralRatio?: InputMaybe<Scalars['BigDecimal']['input']>;
  loanToCollateralRatio_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  loanToCollateralRatio_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  loanToCollateralRatio_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  loanToCollateralRatio_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  loanToCollateralRatio_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  loanToCollateralRatio_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  loanToCollateralRatio_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  loans_?: InputMaybe<CoolerLoan_Filter>;
  or?: InputMaybe<Array<InputMaybe<CoolerLoanRequest_Filter>>>;
  requestEvents_?: InputMaybe<RequestLoanEvent_Filter>;
  requestId?: InputMaybe<Scalars['BigInt']['input']>;
  requestId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  requestId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  requestId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  requestId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  requestId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  requestId_not?: InputMaybe<Scalars['BigInt']['input']>;
  requestId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  rescindEvents_?: InputMaybe<RescindLoanRequestEvent_Filter>;
};

export enum CoolerLoanRequest_OrderBy {
  Amount = 'amount',
  Borrower = 'borrower',
  ClearEvents = 'clearEvents',
  CollateralToken = 'collateralToken',
  Cooler = 'cooler',
  CreatedBlock = 'createdBlock',
  CreatedTimestamp = 'createdTimestamp',
  CreatedTransaction = 'createdTransaction',
  DebtToken = 'debtToken',
  DurationSeconds = 'durationSeconds',
  Id = 'id',
  InterestPercentage = 'interestPercentage',
  IsRescinded = 'isRescinded',
  LoanToCollateralRatio = 'loanToCollateralRatio',
  Loans = 'loans',
  RequestEvents = 'requestEvents',
  RequestId = 'requestId',
  RescindEvents = 'rescindEvents'
}

export type CoolerLoan_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<CoolerLoan_Filter>>>;
  borrower?: InputMaybe<Scalars['String']['input']>;
  borrower_?: InputMaybe<BorrowerStats_Filter>;
  borrower_contains?: InputMaybe<Scalars['String']['input']>;
  borrower_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_ends_with?: InputMaybe<Scalars['String']['input']>;
  borrower_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_gt?: InputMaybe<Scalars['String']['input']>;
  borrower_gte?: InputMaybe<Scalars['String']['input']>;
  borrower_in?: InputMaybe<Array<Scalars['String']['input']>>;
  borrower_lt?: InputMaybe<Scalars['String']['input']>;
  borrower_lte?: InputMaybe<Scalars['String']['input']>;
  borrower_not?: InputMaybe<Scalars['String']['input']>;
  borrower_not_contains?: InputMaybe<Scalars['String']['input']>;
  borrower_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  borrower_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  borrower_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  borrower_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_starts_with?: InputMaybe<Scalars['String']['input']>;
  borrower_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_?: InputMaybe<Clearinghouse_Filter>;
  clearinghouse_contains?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_ends_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_gt?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_gte?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clearinghouse_lt?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_lte?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_contains?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clearinghouse_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_starts_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  collateral?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateral_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateral_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateral_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  collateral_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateral_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateral_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  collateral_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  cooler?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_contains?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_gt?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_gte?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  cooler_lt?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_lte?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_not?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  cooler_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  createdBlock?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdTransaction?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_contains?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_gt?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_gte?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  createdTransaction_lt?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_lte?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_not?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  createdTransaction_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  creationEvents_?: InputMaybe<ClearLoanRequestEvent_Filter>;
  currentExpiryTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  currentExpiryTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  currentExpiryTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  currentExpiryTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  currentExpiryTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  currentExpiryTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  currentExpiryTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  currentExpiryTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  defaultedClaimEvents_?: InputMaybe<ClaimDefaultedLoanEvent_Filter>;
  extendEvents_?: InputMaybe<ExtendLoanEvent_Filter>;
  hasCallback?: InputMaybe<Scalars['Boolean']['input']>;
  hasCallback_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  hasCallback_not?: InputMaybe<Scalars['Boolean']['input']>;
  hasCallback_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  interest?: InputMaybe<Scalars['BigDecimal']['input']>;
  interest_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  interest_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  interest_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  interest_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  interest_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  interest_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  interest_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  loanId?: InputMaybe<Scalars['BigInt']['input']>;
  loanId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  loanId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  loanId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  loanId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  loanId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  loanId_not?: InputMaybe<Scalars['BigInt']['input']>;
  loanId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<CoolerLoan_Filter>>>;
  originalExpiryTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  originalExpiryTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  originalExpiryTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  originalExpiryTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  originalExpiryTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  originalExpiryTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  originalExpiryTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  originalExpiryTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principal?: InputMaybe<Scalars['BigDecimal']['input']>;
  principal_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  principal_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  principal_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  principal_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  principal_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  principal_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  principal_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  repaymentEvents_?: InputMaybe<RepayLoanEvent_Filter>;
  request?: InputMaybe<Scalars['String']['input']>;
  request_?: InputMaybe<CoolerLoanRequest_Filter>;
  request_contains?: InputMaybe<Scalars['String']['input']>;
  request_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  request_ends_with?: InputMaybe<Scalars['String']['input']>;
  request_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  request_gt?: InputMaybe<Scalars['String']['input']>;
  request_gte?: InputMaybe<Scalars['String']['input']>;
  request_in?: InputMaybe<Array<Scalars['String']['input']>>;
  request_lt?: InputMaybe<Scalars['String']['input']>;
  request_lte?: InputMaybe<Scalars['String']['input']>;
  request_not?: InputMaybe<Scalars['String']['input']>;
  request_not_contains?: InputMaybe<Scalars['String']['input']>;
  request_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  request_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  request_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  request_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  request_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  request_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  request_starts_with?: InputMaybe<Scalars['String']['input']>;
  request_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum CoolerLoan_OrderBy {
  Borrower = 'borrower',
  BorrowerActiveLoans = 'borrower__activeLoans',
  BorrowerBorrower = 'borrower__borrower',
  BorrowerCurrentBorrowed = 'borrower__currentBorrowed',
  BorrowerCurrentCollateral = 'borrower__currentCollateral',
  BorrowerCurrentInterestDue = 'borrower__currentInterestDue',
  BorrowerId = 'borrower__id',
  BorrowerLastUpdateBlock = 'borrower__lastUpdateBlock',
  BorrowerLastUpdateTimestamp = 'borrower__lastUpdateTimestamp',
  BorrowerMaxActiveLoans = 'borrower__maxActiveLoans',
  BorrowerMaxBorrowedValue = 'borrower__maxBorrowedValue',
  BorrowerTotalDefaultedLoans = 'borrower__totalDefaultedLoans',
  BorrowerTotalLoanExtensions = 'borrower__totalLoanExtensions',
  BorrowerTotalLoans = 'borrower__totalLoans',
  BorrowerTotalRepaidLoans = 'borrower__totalRepaidLoans',
  Clearinghouse = 'clearinghouse',
  ClearinghouseAddress = 'clearinghouse__address',
  ClearinghouseCollateralToken = 'clearinghouse__collateralToken',
  ClearinghouseCollateralTokenDecimals = 'clearinghouse__collateralTokenDecimals',
  ClearinghouseCoolerFactoryAddress = 'clearinghouse__coolerFactoryAddress',
  ClearinghouseCreatedBlock = 'clearinghouse__createdBlock',
  ClearinghouseCreatedTimestamp = 'clearinghouse__createdTimestamp',
  ClearinghouseDuration = 'clearinghouse__duration',
  ClearinghouseFundAmount = 'clearinghouse__fundAmount',
  ClearinghouseFundCadence = 'clearinghouse__fundCadence',
  ClearinghouseId = 'clearinghouse__id',
  ClearinghouseInterestRate = 'clearinghouse__interestRate',
  ClearinghouseLoanToCollateral = 'clearinghouse__loanToCollateral',
  ClearinghouseReserveToken = 'clearinghouse__reserveToken',
  ClearinghouseReserveTokenDecimals = 'clearinghouse__reserveTokenDecimals',
  ClearinghouseSReserveToken = 'clearinghouse__sReserveToken',
  ClearinghouseSReserveTokenDecimals = 'clearinghouse__sReserveTokenDecimals',
  ClearinghouseVersion = 'clearinghouse__version',
  Collateral = 'collateral',
  Cooler = 'cooler',
  CreatedBlock = 'createdBlock',
  CreatedTimestamp = 'createdTimestamp',
  CreatedTransaction = 'createdTransaction',
  CreationEvents = 'creationEvents',
  CurrentExpiryTimestamp = 'currentExpiryTimestamp',
  DefaultedClaimEvents = 'defaultedClaimEvents',
  ExtendEvents = 'extendEvents',
  HasCallback = 'hasCallback',
  Id = 'id',
  Interest = 'interest',
  LoanId = 'loanId',
  OriginalExpiryTimestamp = 'originalExpiryTimestamp',
  Principal = 'principal',
  RepaymentEvents = 'repaymentEvents',
  Request = 'request',
  RequestAmount = 'request__amount',
  RequestBorrower = 'request__borrower',
  RequestCollateralToken = 'request__collateralToken',
  RequestCooler = 'request__cooler',
  RequestCreatedBlock = 'request__createdBlock',
  RequestCreatedTimestamp = 'request__createdTimestamp',
  RequestCreatedTransaction = 'request__createdTransaction',
  RequestDebtToken = 'request__debtToken',
  RequestDurationSeconds = 'request__durationSeconds',
  RequestId = 'request__id',
  RequestInterestPercentage = 'request__interestPercentage',
  RequestIsRescinded = 'request__isRescinded',
  RequestLoanToCollateralRatio = 'request__loanToCollateralRatio',
  RequestRequestId = 'request__requestId'
}

/** Aggregated default statistics */
export type DefaultStats = {
  __typename?: 'DefaultStats';
  clearinghouse: Scalars['BigInt']['output'];
  defaultCount: Scalars['Int']['output'];
  firstCollateralPrice: Scalars['BigDecimal']['output'];
  id: Scalars['Int8']['output'];
  lastCollateralPrice: Scalars['BigDecimal']['output'];
  maxCollateralClaimed: Scalars['BigDecimal']['output'];
  maxCollateralPrice: Scalars['BigDecimal']['output'];
  maxPrincipalDefaulted: Scalars['BigDecimal']['output'];
  maxSecondsSinceExpiry: Scalars['BigInt']['output'];
  maxValueClaimed: Scalars['BigDecimal']['output'];
  minCollateralClaimed: Scalars['BigDecimal']['output'];
  minCollateralPrice: Scalars['BigDecimal']['output'];
  minPrincipalDefaulted: Scalars['BigDecimal']['output'];
  minSecondsSinceExpiry: Scalars['BigInt']['output'];
  minValueClaimed: Scalars['BigDecimal']['output'];
  timestamp: Scalars['Timestamp']['output'];
  totalCollateralClaimed: Scalars['BigDecimal']['output'];
  totalPrincipalDefaulted: Scalars['BigDecimal']['output'];
  totalValueClaimed: Scalars['BigDecimal']['output'];
};

export type DefaultStats_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DefaultStats_Filter>>>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  or?: InputMaybe<Array<InputMaybe<DefaultStats_Filter>>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum DefaultStats_OrderBy {
  Clearinghouse = 'clearinghouse',
  DefaultCount = 'defaultCount',
  FirstCollateralPrice = 'firstCollateralPrice',
  Id = 'id',
  LastCollateralPrice = 'lastCollateralPrice',
  MaxCollateralClaimed = 'maxCollateralClaimed',
  MaxCollateralPrice = 'maxCollateralPrice',
  MaxPrincipalDefaulted = 'maxPrincipalDefaulted',
  MaxSecondsSinceExpiry = 'maxSecondsSinceExpiry',
  MaxValueClaimed = 'maxValueClaimed',
  MinCollateralClaimed = 'minCollateralClaimed',
  MinCollateralPrice = 'minCollateralPrice',
  MinPrincipalDefaulted = 'minPrincipalDefaulted',
  MinSecondsSinceExpiry = 'minSecondsSinceExpiry',
  MinValueClaimed = 'minValueClaimed',
  Timestamp = 'timestamp',
  TotalCollateralClaimed = 'totalCollateralClaimed',
  TotalPrincipalDefaulted = 'totalPrincipalDefaulted',
  TotalValueClaimed = 'totalValueClaimed'
}

export type DefundEvent = {
  __typename?: 'DefundEvent';
  /** Amount of reserve tokens in (positive)/out (negative) of the Clearinghouse. */
  amount: Scalars['BigDecimal']['output'];
  /** Block number at the time of the event. */
  blockNumber: Scalars['BigInt']['output'];
  /** Block timestamp at the time of the event. */
  blockTimestamp: Scalars['BigInt']['output'];
  /** Address of the Clearinghouse. */
  clearinghouse: Clearinghouse;
  /** Event date in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /**
   * Record ID.
   *
   * In the format of `clearinghouse-blockNumber`.
   */
  id: Scalars['String']['output'];
  /** Transaction hash of the event. */
  transactionHash: Scalars['Bytes']['output'];
};

export type DefundEvent_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  and?: InputMaybe<Array<InputMaybe<DefundEvent_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  clearinghouse?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_?: InputMaybe<Clearinghouse_Filter>;
  clearinghouse_contains?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_ends_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_gt?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_gte?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clearinghouse_lt?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_lte?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_contains?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clearinghouse_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_starts_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  date_contains?: InputMaybe<Scalars['String']['input']>;
  date_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_gt?: InputMaybe<Scalars['String']['input']>;
  date_gte?: InputMaybe<Scalars['String']['input']>;
  date_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_lt?: InputMaybe<Scalars['String']['input']>;
  date_lte?: InputMaybe<Scalars['String']['input']>;
  date_not?: InputMaybe<Scalars['String']['input']>;
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  date_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<DefundEvent_Filter>>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum DefundEvent_OrderBy {
  Amount = 'amount',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Clearinghouse = 'clearinghouse',
  ClearinghouseAddress = 'clearinghouse__address',
  ClearinghouseCollateralToken = 'clearinghouse__collateralToken',
  ClearinghouseCollateralTokenDecimals = 'clearinghouse__collateralTokenDecimals',
  ClearinghouseCoolerFactoryAddress = 'clearinghouse__coolerFactoryAddress',
  ClearinghouseCreatedBlock = 'clearinghouse__createdBlock',
  ClearinghouseCreatedTimestamp = 'clearinghouse__createdTimestamp',
  ClearinghouseDuration = 'clearinghouse__duration',
  ClearinghouseFundAmount = 'clearinghouse__fundAmount',
  ClearinghouseFundCadence = 'clearinghouse__fundCadence',
  ClearinghouseId = 'clearinghouse__id',
  ClearinghouseInterestRate = 'clearinghouse__interestRate',
  ClearinghouseLoanToCollateral = 'clearinghouse__loanToCollateral',
  ClearinghouseReserveToken = 'clearinghouse__reserveToken',
  ClearinghouseReserveTokenDecimals = 'clearinghouse__reserveTokenDecimals',
  ClearinghouseSReserveToken = 'clearinghouse__sReserveToken',
  ClearinghouseSReserveTokenDecimals = 'clearinghouse__sReserveTokenDecimals',
  ClearinghouseVersion = 'clearinghouse__version',
  Date = 'date',
  Id = 'id',
  TransactionHash = 'transactionHash'
}

export type ExtendLoanEvent = {
  __typename?: 'ExtendLoanEvent';
  /** Block number at the time of the event. */
  blockNumber: Scalars['BigInt']['output'];
  /** Block timestamp at the time of the event. */
  blockTimestamp: Scalars['BigInt']['output'];
  /** Event date in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /** The new expiry timestamp. */
  expiryTimestamp: Scalars['BigInt']['output'];
  /**
   * Record ID.
   *
   * In the format of `cooler-loanId`.
   */
  id: Scalars['Int8']['output'];
  /** Amount of interest due after the extension. */
  interestDue: Scalars['BigDecimal']['output'];
  /** Loan that was extended. */
  loan: CoolerLoan;
  /** Number of duration periods the loan has been extended for. */
  periods: Scalars['Int']['output'];
  /** Timestamp of the event. */
  timestamp: Scalars['Timestamp']['output'];
  /** Transaction hash of the event. */
  transactionHash: Scalars['Bytes']['output'];
};

export type ExtendLoanEvent_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ExtendLoanEvent_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  date_contains?: InputMaybe<Scalars['String']['input']>;
  date_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_gt?: InputMaybe<Scalars['String']['input']>;
  date_gte?: InputMaybe<Scalars['String']['input']>;
  date_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_lt?: InputMaybe<Scalars['String']['input']>;
  date_lte?: InputMaybe<Scalars['String']['input']>;
  date_not?: InputMaybe<Scalars['String']['input']>;
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  date_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  expiryTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  expiryTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  expiryTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  expiryTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  expiryTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  expiryTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  expiryTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  expiryTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  id_not?: InputMaybe<Scalars['Int8']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  interestDue?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestDue_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestDue_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestDue_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  interestDue_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestDue_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestDue_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestDue_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<CoolerLoan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<ExtendLoanEvent_Filter>>>;
  periods?: InputMaybe<Scalars['Int']['input']>;
  periods_gt?: InputMaybe<Scalars['Int']['input']>;
  periods_gte?: InputMaybe<Scalars['Int']['input']>;
  periods_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  periods_lt?: InputMaybe<Scalars['Int']['input']>;
  periods_lte?: InputMaybe<Scalars['Int']['input']>;
  periods_not?: InputMaybe<Scalars['Int']['input']>;
  periods_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum ExtendLoanEvent_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Date = 'date',
  ExpiryTimestamp = 'expiryTimestamp',
  Id = 'id',
  InterestDue = 'interestDue',
  Loan = 'loan',
  LoanCollateral = 'loan__collateral',
  LoanCooler = 'loan__cooler',
  LoanCreatedBlock = 'loan__createdBlock',
  LoanCreatedTimestamp = 'loan__createdTimestamp',
  LoanCreatedTransaction = 'loan__createdTransaction',
  LoanCurrentExpiryTimestamp = 'loan__currentExpiryTimestamp',
  LoanHasCallback = 'loan__hasCallback',
  LoanId = 'loan__id',
  LoanInterest = 'loan__interest',
  LoanLoanId = 'loan__loanId',
  LoanOriginalExpiryTimestamp = 'loan__originalExpiryTimestamp',
  LoanPrincipal = 'loan__principal',
  Periods = 'periods',
  Timestamp = 'timestamp',
  TransactionHash = 'transactionHash'
}

/** Aggregated extension statistics */
export type ExtensionStats = {
  __typename?: 'ExtensionStats';
  clearinghouse: Scalars['BigInt']['output'];
  extensionCount: Scalars['Int']['output'];
  id: Scalars['Int8']['output'];
  maxNewInterest: Scalars['BigDecimal']['output'];
  maxPeriods: Scalars['Int']['output'];
  minNewInterest: Scalars['BigDecimal']['output'];
  minPeriods: Scalars['Int']['output'];
  timestamp: Scalars['Timestamp']['output'];
  totalNewInterest: Scalars['BigDecimal']['output'];
  totalPeriods: Scalars['Int']['output'];
};

export type ExtensionStats_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ExtensionStats_Filter>>>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  or?: InputMaybe<Array<InputMaybe<ExtensionStats_Filter>>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum ExtensionStats_OrderBy {
  Clearinghouse = 'clearinghouse',
  ExtensionCount = 'extensionCount',
  Id = 'id',
  MaxNewInterest = 'maxNewInterest',
  MaxPeriods = 'maxPeriods',
  MinNewInterest = 'minNewInterest',
  MinPeriods = 'minPeriods',
  Timestamp = 'timestamp',
  TotalNewInterest = 'totalNewInterest',
  TotalPeriods = 'totalPeriods'
}

export type MonoCoolerAccount = {
  __typename?: 'MonoCoolerAccount';
  activities: Array<MonoCoolerActivity>;
  address: Scalars['Bytes']['output'];
  collateral: Scalars['BigInt']['output'];
  debt: Scalars['BigInt']['output'];
  healthFactor: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  interestAccumulatorRay: Scalars['BigInt']['output'];
  ltv: Scalars['BigInt']['output'];
  snapshots: Array<MonoCoolerAccountSnapshot>;
  updatedAt: Scalars['BigInt']['output'];
};


export type MonoCoolerAccountActivitiesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerActivity_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonoCoolerActivity_Filter>;
};


export type MonoCoolerAccountSnapshotsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerAccountSnapshot_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonoCoolerAccountSnapshot_Filter>;
};

export type MonoCoolerAccountSnapshot = {
  __typename?: 'MonoCoolerAccountSnapshot';
  account: MonoCoolerAccount;
  collateral: Scalars['BigInt']['output'];
  debt: Scalars['BigInt']['output'];
  healthFactor: Scalars['BigInt']['output'];
  id: Scalars['Int8']['output'];
  liquidationLtv: Scalars['BigInt']['output'];
  ltv: Scalars['BigInt']['output'];
  maxOriginationLtv: Scalars['BigInt']['output'];
  timestamp: Scalars['Timestamp']['output'];
};

export type MonoCoolerAccountSnapshot_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<MonoCoolerAccount_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<InputMaybe<MonoCoolerAccountSnapshot_Filter>>>;
  collateral?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateral_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debt?: InputMaybe<Scalars['BigInt']['input']>;
  debt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  debt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  debt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  debt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  debt_not?: InputMaybe<Scalars['BigInt']['input']>;
  debt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  healthFactor?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_gt?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_gte?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  healthFactor_lt?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_lte?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_not?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  id_not?: InputMaybe<Scalars['Int8']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  liquidationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  ltv?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  ltv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_not?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxOriginationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxOriginationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<MonoCoolerAccountSnapshot_Filter>>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export enum MonoCoolerAccountSnapshot_OrderBy {
  Account = 'account',
  AccountAddress = 'account__address',
  AccountCollateral = 'account__collateral',
  AccountDebt = 'account__debt',
  AccountHealthFactor = 'account__healthFactor',
  AccountId = 'account__id',
  AccountInterestAccumulatorRay = 'account__interestAccumulatorRay',
  AccountLtv = 'account__ltv',
  AccountUpdatedAt = 'account__updatedAt',
  Collateral = 'collateral',
  Debt = 'debt',
  HealthFactor = 'healthFactor',
  Id = 'id',
  LiquidationLtv = 'liquidationLtv',
  Ltv = 'ltv',
  MaxOriginationLtv = 'maxOriginationLtv',
  Timestamp = 'timestamp'
}

export type MonoCoolerAccount_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  activities_?: InputMaybe<MonoCoolerActivity_Filter>;
  address?: InputMaybe<Scalars['Bytes']['input']>;
  address_contains?: InputMaybe<Scalars['Bytes']['input']>;
  address_gt?: InputMaybe<Scalars['Bytes']['input']>;
  address_gte?: InputMaybe<Scalars['Bytes']['input']>;
  address_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  address_lt?: InputMaybe<Scalars['Bytes']['input']>;
  address_lte?: InputMaybe<Scalars['Bytes']['input']>;
  address_not?: InputMaybe<Scalars['Bytes']['input']>;
  address_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  address_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  and?: InputMaybe<Array<InputMaybe<MonoCoolerAccount_Filter>>>;
  collateral?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateral_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debt?: InputMaybe<Scalars['BigInt']['input']>;
  debt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  debt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  debt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  debt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  debt_not?: InputMaybe<Scalars['BigInt']['input']>;
  debt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  healthFactor?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_gt?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_gte?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  healthFactor_lt?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_lte?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_not?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interestAccumulatorRay?: InputMaybe<Scalars['BigInt']['input']>;
  interestAccumulatorRay_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestAccumulatorRay_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestAccumulatorRay_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestAccumulatorRay_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestAccumulatorRay_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestAccumulatorRay_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestAccumulatorRay_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  ltv?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  ltv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_not?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<MonoCoolerAccount_Filter>>>;
  snapshots_?: InputMaybe<MonoCoolerAccountSnapshot_Filter>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum MonoCoolerAccount_OrderBy {
  Activities = 'activities',
  Address = 'address',
  Collateral = 'collateral',
  Debt = 'debt',
  HealthFactor = 'healthFactor',
  Id = 'id',
  InterestAccumulatorRay = 'interestAccumulatorRay',
  Ltv = 'ltv',
  Snapshots = 'snapshots',
  UpdatedAt = 'updatedAt'
}

export type MonoCoolerActivity = {
  __typename?: 'MonoCoolerActivity';
  account: MonoCoolerAccount;
  amount: Scalars['BigInt']['output'];
  collateral?: Maybe<Scalars['BigInt']['output']>;
  collateralSeized?: Maybe<Scalars['BigInt']['output']>;
  debt?: Maybe<Scalars['BigInt']['output']>;
  debtWiped?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
  liquidationIncentive?: Maybe<Scalars['BigInt']['output']>;
  liquidationLtv?: Maybe<Scalars['BigInt']['output']>;
  ltv?: Maybe<Scalars['BigInt']['output']>;
  maxOriginationLtv?: Maybe<Scalars['BigInt']['output']>;
  timestamp: Scalars['BigInt']['output'];
  txHash: Scalars['Bytes']['output'];
  type: Scalars['String']['output'];
};

export type MonoCoolerActivity_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<MonoCoolerAccount_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<MonoCoolerActivity_Filter>>>;
  collateral?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralSeized_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateral_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateral_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateral_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debt?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped_gt?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped_gte?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debtWiped_lt?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped_lte?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped_not?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  debt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  debt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  debt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  debt_not?: InputMaybe<Scalars['BigInt']['input']>;
  debt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidationIncentive?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationIncentive_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationIncentive_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationIncentive_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidationIncentive_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationIncentive_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationIncentive_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationIncentive_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  ltv?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  ltv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_not?: InputMaybe<Scalars['BigInt']['input']>;
  ltv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxOriginationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxOriginationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<MonoCoolerActivity_Filter>>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  txHash?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  txHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  type_ends_with?: InputMaybe<Scalars['String']['input']>;
  type_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type_gt?: InputMaybe<Scalars['String']['input']>;
  type_gte?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  type_lt?: InputMaybe<Scalars['String']['input']>;
  type_lte?: InputMaybe<Scalars['String']['input']>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  type_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  type_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  type_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  type_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type_starts_with?: InputMaybe<Scalars['String']['input']>;
  type_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum MonoCoolerActivity_OrderBy {
  Account = 'account',
  AccountAddress = 'account__address',
  AccountCollateral = 'account__collateral',
  AccountDebt = 'account__debt',
  AccountHealthFactor = 'account__healthFactor',
  AccountId = 'account__id',
  AccountInterestAccumulatorRay = 'account__interestAccumulatorRay',
  AccountLtv = 'account__ltv',
  AccountUpdatedAt = 'account__updatedAt',
  Amount = 'amount',
  Collateral = 'collateral',
  CollateralSeized = 'collateralSeized',
  Debt = 'debt',
  DebtWiped = 'debtWiped',
  Id = 'id',
  LiquidationIncentive = 'liquidationIncentive',
  LiquidationLtv = 'liquidationLtv',
  Ltv = 'ltv',
  MaxOriginationLtv = 'maxOriginationLtv',
  Timestamp = 'timestamp',
  TxHash = 'txHash',
  Type = 'type'
}

export type MonoCoolerGlobalSnapshot = {
  __typename?: 'MonoCoolerGlobalSnapshot';
  globalState: MonoCoolerGlobalState;
  id: Scalars['Int8']['output'];
  interestRateWad: Scalars['BigInt']['output'];
  liquidationLtv: Scalars['BigInt']['output'];
  maxOriginationLtv: Scalars['BigInt']['output'];
  timestamp: Scalars['Timestamp']['output'];
  totalCollateral: Scalars['BigInt']['output'];
  totalDebt: Scalars['BigInt']['output'];
};

export type MonoCoolerGlobalSnapshot_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MonoCoolerGlobalSnapshot_Filter>>>;
  globalState?: InputMaybe<Scalars['String']['input']>;
  globalState_?: InputMaybe<MonoCoolerGlobalState_Filter>;
  globalState_contains?: InputMaybe<Scalars['String']['input']>;
  globalState_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  globalState_ends_with?: InputMaybe<Scalars['String']['input']>;
  globalState_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  globalState_gt?: InputMaybe<Scalars['String']['input']>;
  globalState_gte?: InputMaybe<Scalars['String']['input']>;
  globalState_in?: InputMaybe<Array<Scalars['String']['input']>>;
  globalState_lt?: InputMaybe<Scalars['String']['input']>;
  globalState_lte?: InputMaybe<Scalars['String']['input']>;
  globalState_not?: InputMaybe<Scalars['String']['input']>;
  globalState_not_contains?: InputMaybe<Scalars['String']['input']>;
  globalState_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  globalState_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  globalState_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  globalState_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  globalState_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  globalState_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  globalState_starts_with?: InputMaybe<Scalars['String']['input']>;
  globalState_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  id_not?: InputMaybe<Scalars['Int8']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  interestRateWad?: InputMaybe<Scalars['BigInt']['input']>;
  interestRateWad_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestRateWad_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestRateWad_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestRateWad_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestRateWad_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestRateWad_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestRateWad_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxOriginationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxOriginationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<MonoCoolerGlobalSnapshot_Filter>>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  totalCollateral?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalCollateral_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalDebt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDebt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDebt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalDebt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalDebt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDebt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalDebt_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalDebt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum MonoCoolerGlobalSnapshot_OrderBy {
  GlobalState = 'globalState',
  GlobalStateBorrowsPaused = 'globalState__borrowsPaused',
  GlobalStateId = 'globalState__id',
  GlobalStateInterestAccumulatorRay = 'globalState__interestAccumulatorRay',
  GlobalStateInterestRateWad = 'globalState__interestRateWad',
  GlobalStateLiquidationPaused = 'globalState__liquidationPaused',
  GlobalStateLtvOracle = 'globalState__ltvOracle',
  GlobalStateTotalCollateral = 'globalState__totalCollateral',
  GlobalStateTotalDebt = 'globalState__totalDebt',
  GlobalStateTreasuryBorrower = 'globalState__treasuryBorrower',
  GlobalStateUpdatedAt = 'globalState__updatedAt',
  Id = 'id',
  InterestRateWad = 'interestRateWad',
  LiquidationLtv = 'liquidationLtv',
  MaxOriginationLtv = 'maxOriginationLtv',
  Timestamp = 'timestamp',
  TotalCollateral = 'totalCollateral',
  TotalDebt = 'totalDebt'
}

export type MonoCoolerGlobalState = {
  __typename?: 'MonoCoolerGlobalState';
  borrowsPaused: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  interestAccumulatorRay: Scalars['BigInt']['output'];
  interestRateWad: Scalars['BigInt']['output'];
  liquidationPaused: Scalars['Boolean']['output'];
  ltvOracle: Scalars['Bytes']['output'];
  ltvOracleChanges: Array<MonoCoolerLtvOracleChange>;
  snapshots: Array<MonoCoolerGlobalSnapshot>;
  totalCollateral: Scalars['BigInt']['output'];
  totalDebt: Scalars['BigInt']['output'];
  treasuryBorrower: Scalars['Bytes']['output'];
  updatedAt: Scalars['BigInt']['output'];
};


export type MonoCoolerGlobalStateLtvOracleChangesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerLtvOracleChange_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonoCoolerLtvOracleChange_Filter>;
};


export type MonoCoolerGlobalStateSnapshotsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerGlobalSnapshot_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonoCoolerGlobalSnapshot_Filter>;
};

export type MonoCoolerGlobalState_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MonoCoolerGlobalState_Filter>>>;
  borrowsPaused?: InputMaybe<Scalars['Boolean']['input']>;
  borrowsPaused_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  borrowsPaused_not?: InputMaybe<Scalars['Boolean']['input']>;
  borrowsPaused_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interestAccumulatorRay?: InputMaybe<Scalars['BigInt']['input']>;
  interestAccumulatorRay_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestAccumulatorRay_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestAccumulatorRay_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestAccumulatorRay_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestAccumulatorRay_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestAccumulatorRay_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestAccumulatorRay_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestRateWad?: InputMaybe<Scalars['BigInt']['input']>;
  interestRateWad_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestRateWad_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestRateWad_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestRateWad_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestRateWad_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestRateWad_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestRateWad_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidationPaused?: InputMaybe<Scalars['Boolean']['input']>;
  liquidationPaused_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  liquidationPaused_not?: InputMaybe<Scalars['Boolean']['input']>;
  liquidationPaused_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  ltvOracle?: InputMaybe<Scalars['Bytes']['input']>;
  ltvOracleChanges_?: InputMaybe<MonoCoolerLtvOracleChange_Filter>;
  ltvOracle_contains?: InputMaybe<Scalars['Bytes']['input']>;
  ltvOracle_gt?: InputMaybe<Scalars['Bytes']['input']>;
  ltvOracle_gte?: InputMaybe<Scalars['Bytes']['input']>;
  ltvOracle_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  ltvOracle_lt?: InputMaybe<Scalars['Bytes']['input']>;
  ltvOracle_lte?: InputMaybe<Scalars['Bytes']['input']>;
  ltvOracle_not?: InputMaybe<Scalars['Bytes']['input']>;
  ltvOracle_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  ltvOracle_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<MonoCoolerGlobalState_Filter>>>;
  snapshots_?: InputMaybe<MonoCoolerGlobalSnapshot_Filter>;
  totalCollateral?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalCollateral_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalDebt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDebt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDebt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalDebt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalDebt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDebt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalDebt_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalDebt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  treasuryBorrower?: InputMaybe<Scalars['Bytes']['input']>;
  treasuryBorrower_contains?: InputMaybe<Scalars['Bytes']['input']>;
  treasuryBorrower_gt?: InputMaybe<Scalars['Bytes']['input']>;
  treasuryBorrower_gte?: InputMaybe<Scalars['Bytes']['input']>;
  treasuryBorrower_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  treasuryBorrower_lt?: InputMaybe<Scalars['Bytes']['input']>;
  treasuryBorrower_lte?: InputMaybe<Scalars['Bytes']['input']>;
  treasuryBorrower_not?: InputMaybe<Scalars['Bytes']['input']>;
  treasuryBorrower_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  treasuryBorrower_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum MonoCoolerGlobalState_OrderBy {
  BorrowsPaused = 'borrowsPaused',
  Id = 'id',
  InterestAccumulatorRay = 'interestAccumulatorRay',
  InterestRateWad = 'interestRateWad',
  LiquidationPaused = 'liquidationPaused',
  LtvOracle = 'ltvOracle',
  LtvOracleChanges = 'ltvOracleChanges',
  Snapshots = 'snapshots',
  TotalCollateral = 'totalCollateral',
  TotalDebt = 'totalDebt',
  TreasuryBorrower = 'treasuryBorrower',
  UpdatedAt = 'updatedAt'
}

/** Aggregated global state statistics */
export type MonoCoolerGlobalStats = {
  __typename?: 'MonoCoolerGlobalStats';
  id: Scalars['Int8']['output'];
  interestRateWad: Scalars['BigInt']['output'];
  liquidationLtv: Scalars['BigInt']['output'];
  maxOriginationLtv: Scalars['BigInt']['output'];
  snapshotCount: Scalars['Int']['output'];
  timestamp: Scalars['Timestamp']['output'];
  totalCollateral: Scalars['BigInt']['output'];
  totalDebt: Scalars['BigInt']['output'];
};

export type MonoCoolerGlobalStats_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MonoCoolerGlobalStats_Filter>>>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  or?: InputMaybe<Array<InputMaybe<MonoCoolerGlobalStats_Filter>>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum MonoCoolerGlobalStats_OrderBy {
  Id = 'id',
  InterestRateWad = 'interestRateWad',
  LiquidationLtv = 'liquidationLtv',
  MaxOriginationLtv = 'maxOriginationLtv',
  SnapshotCount = 'snapshotCount',
  Timestamp = 'timestamp',
  TotalCollateral = 'totalCollateral',
  TotalDebt = 'totalDebt'
}

/** Tracks LTV at time of liquidation */
export type MonoCoolerLiquidation = {
  __typename?: 'MonoCoolerLiquidation';
  account: MonoCoolerAccount;
  collateralSeized: Scalars['BigInt']['output'];
  debtWiped: Scalars['BigInt']['output'];
  excessLtv: Scalars['BigInt']['output'];
  healthFactorAtLiquidation: Scalars['BigInt']['output'];
  id: Scalars['Int8']['output'];
  incentiveReceived: Scalars['BigInt']['output'];
  liquidationLtv: Scalars['BigInt']['output'];
  liquidator: Scalars['Bytes']['output'];
  ltvAtLiquidation: Scalars['BigInt']['output'];
  maxOriginationLtv: Scalars['BigInt']['output'];
  timestamp: Scalars['Timestamp']['output'];
  txHash: Scalars['Bytes']['output'];
};

/** Aggregated liquidation statistics */
export type MonoCoolerLiquidationStats = {
  __typename?: 'MonoCoolerLiquidationStats';
  id: Scalars['Int8']['output'];
  liquidationCount: Scalars['Int']['output'];
  maxExcessLtv: Scalars['BigInt']['output'];
  maxLiquidationLtv: Scalars['BigInt']['output'];
  minHealthFactorAtLiquidation: Scalars['BigInt']['output'];
  timestamp: Scalars['Timestamp']['output'];
  totalCollateralSeized: Scalars['BigInt']['output'];
  totalDebtWiped: Scalars['BigInt']['output'];
  totalIncentives: Scalars['BigInt']['output'];
};

export type MonoCoolerLiquidationStats_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MonoCoolerLiquidationStats_Filter>>>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  or?: InputMaybe<Array<InputMaybe<MonoCoolerLiquidationStats_Filter>>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum MonoCoolerLiquidationStats_OrderBy {
  Id = 'id',
  LiquidationCount = 'liquidationCount',
  MaxExcessLtv = 'maxExcessLtv',
  MaxLiquidationLtv = 'maxLiquidationLtv',
  MinHealthFactorAtLiquidation = 'minHealthFactorAtLiquidation',
  Timestamp = 'timestamp',
  TotalCollateralSeized = 'totalCollateralSeized',
  TotalDebtWiped = 'totalDebtWiped',
  TotalIncentives = 'totalIncentives'
}

export type MonoCoolerLiquidation_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<MonoCoolerAccount_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<InputMaybe<MonoCoolerLiquidation_Filter>>>;
  collateralSeized?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralSeized_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSeized_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debtWiped?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped_gt?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped_gte?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debtWiped_lt?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped_lte?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped_not?: InputMaybe<Scalars['BigInt']['input']>;
  debtWiped_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  excessLtv?: InputMaybe<Scalars['BigInt']['input']>;
  excessLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  excessLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  excessLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  excessLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  excessLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  excessLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  excessLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  healthFactorAtLiquidation?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactorAtLiquidation_gt?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactorAtLiquidation_gte?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactorAtLiquidation_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  healthFactorAtLiquidation_lt?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactorAtLiquidation_lte?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactorAtLiquidation_not?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactorAtLiquidation_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  id_not?: InputMaybe<Scalars['Int8']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  incentiveReceived?: InputMaybe<Scalars['BigInt']['input']>;
  incentiveReceived_gt?: InputMaybe<Scalars['BigInt']['input']>;
  incentiveReceived_gte?: InputMaybe<Scalars['BigInt']['input']>;
  incentiveReceived_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  incentiveReceived_lt?: InputMaybe<Scalars['BigInt']['input']>;
  incentiveReceived_lte?: InputMaybe<Scalars['BigInt']['input']>;
  incentiveReceived_not?: InputMaybe<Scalars['BigInt']['input']>;
  incentiveReceived_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidator?: InputMaybe<Scalars['Bytes']['input']>;
  liquidator_contains?: InputMaybe<Scalars['Bytes']['input']>;
  liquidator_gt?: InputMaybe<Scalars['Bytes']['input']>;
  liquidator_gte?: InputMaybe<Scalars['Bytes']['input']>;
  liquidator_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  liquidator_lt?: InputMaybe<Scalars['Bytes']['input']>;
  liquidator_lte?: InputMaybe<Scalars['Bytes']['input']>;
  liquidator_not?: InputMaybe<Scalars['Bytes']['input']>;
  liquidator_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  liquidator_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  ltvAtLiquidation?: InputMaybe<Scalars['BigInt']['input']>;
  ltvAtLiquidation_gt?: InputMaybe<Scalars['BigInt']['input']>;
  ltvAtLiquidation_gte?: InputMaybe<Scalars['BigInt']['input']>;
  ltvAtLiquidation_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  ltvAtLiquidation_lt?: InputMaybe<Scalars['BigInt']['input']>;
  ltvAtLiquidation_lte?: InputMaybe<Scalars['BigInt']['input']>;
  ltvAtLiquidation_not?: InputMaybe<Scalars['BigInt']['input']>;
  ltvAtLiquidation_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxOriginationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxOriginationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<MonoCoolerLiquidation_Filter>>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  txHash?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  txHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum MonoCoolerLiquidation_OrderBy {
  Account = 'account',
  AccountAddress = 'account__address',
  AccountCollateral = 'account__collateral',
  AccountDebt = 'account__debt',
  AccountHealthFactor = 'account__healthFactor',
  AccountId = 'account__id',
  AccountInterestAccumulatorRay = 'account__interestAccumulatorRay',
  AccountLtv = 'account__ltv',
  AccountUpdatedAt = 'account__updatedAt',
  CollateralSeized = 'collateralSeized',
  DebtWiped = 'debtWiped',
  ExcessLtv = 'excessLtv',
  HealthFactorAtLiquidation = 'healthFactorAtLiquidation',
  Id = 'id',
  IncentiveReceived = 'incentiveReceived',
  LiquidationLtv = 'liquidationLtv',
  Liquidator = 'liquidator',
  LtvAtLiquidation = 'ltvAtLiquidation',
  MaxOriginationLtv = 'maxOriginationLtv',
  Timestamp = 'timestamp',
  TxHash = 'txHash'
}

/** Tracks LTV at time of loan origination */
export type MonoCoolerLoanOrigination = {
  __typename?: 'MonoCoolerLoanOrigination';
  account: MonoCoolerAccount;
  borrowAmount: Scalars['BigInt']['output'];
  collateralAtTime: Scalars['BigInt']['output'];
  debtAtTime: Scalars['BigInt']['output'];
  healthFactor: Scalars['BigInt']['output'];
  id: Scalars['Int8']['output'];
  liquidationLtv: Scalars['BigInt']['output'];
  maxOriginationLtv: Scalars['BigInt']['output'];
  resultingLtv: Scalars['BigInt']['output'];
  timestamp: Scalars['Timestamp']['output'];
  txHash: Scalars['Bytes']['output'];
  utilizationRatio: Scalars['BigInt']['output'];
};

export type MonoCoolerLoanOrigination_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<MonoCoolerAccount_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<InputMaybe<MonoCoolerLoanOrigination_Filter>>>;
  borrowAmount?: InputMaybe<Scalars['BigInt']['input']>;
  borrowAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  borrowAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  borrowAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  borrowAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  borrowAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  borrowAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  borrowAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralAtTime?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAtTime_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAtTime_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAtTime_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralAtTime_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAtTime_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAtTime_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAtTime_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debtAtTime?: InputMaybe<Scalars['BigInt']['input']>;
  debtAtTime_gt?: InputMaybe<Scalars['BigInt']['input']>;
  debtAtTime_gte?: InputMaybe<Scalars['BigInt']['input']>;
  debtAtTime_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debtAtTime_lt?: InputMaybe<Scalars['BigInt']['input']>;
  debtAtTime_lte?: InputMaybe<Scalars['BigInt']['input']>;
  debtAtTime_not?: InputMaybe<Scalars['BigInt']['input']>;
  debtAtTime_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  healthFactor?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_gt?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_gte?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  healthFactor_lt?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_lte?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_not?: InputMaybe<Scalars['BigInt']['input']>;
  healthFactor_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  id_not?: InputMaybe<Scalars['Int8']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  liquidationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxOriginationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxOriginationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  maxOriginationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<MonoCoolerLoanOrigination_Filter>>>;
  resultingLtv?: InputMaybe<Scalars['BigInt']['input']>;
  resultingLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  resultingLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  resultingLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  resultingLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  resultingLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  resultingLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  resultingLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  txHash?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  txHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  txHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  utilizationRatio?: InputMaybe<Scalars['BigInt']['input']>;
  utilizationRatio_gt?: InputMaybe<Scalars['BigInt']['input']>;
  utilizationRatio_gte?: InputMaybe<Scalars['BigInt']['input']>;
  utilizationRatio_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  utilizationRatio_lt?: InputMaybe<Scalars['BigInt']['input']>;
  utilizationRatio_lte?: InputMaybe<Scalars['BigInt']['input']>;
  utilizationRatio_not?: InputMaybe<Scalars['BigInt']['input']>;
  utilizationRatio_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum MonoCoolerLoanOrigination_OrderBy {
  Account = 'account',
  AccountAddress = 'account__address',
  AccountCollateral = 'account__collateral',
  AccountDebt = 'account__debt',
  AccountHealthFactor = 'account__healthFactor',
  AccountId = 'account__id',
  AccountInterestAccumulatorRay = 'account__interestAccumulatorRay',
  AccountLtv = 'account__ltv',
  AccountUpdatedAt = 'account__updatedAt',
  BorrowAmount = 'borrowAmount',
  CollateralAtTime = 'collateralAtTime',
  DebtAtTime = 'debtAtTime',
  HealthFactor = 'healthFactor',
  Id = 'id',
  LiquidationLtv = 'liquidationLtv',
  MaxOriginationLtv = 'maxOriginationLtv',
  ResultingLtv = 'resultingLtv',
  Timestamp = 'timestamp',
  TxHash = 'txHash',
  UtilizationRatio = 'utilizationRatio'
}

/** Tracks changes to the LTV Oracle over time */
export type MonoCoolerLtvOracleChange = {
  __typename?: 'MonoCoolerLtvOracleChange';
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['BigInt']['output'];
  globalState: MonoCoolerGlobalState;
  id: Scalars['ID']['output'];
  newLiquidationLtv: Scalars['BigInt']['output'];
  newMaxOriginationLtv: Scalars['BigInt']['output'];
  newOracle: Scalars['Bytes']['output'];
  oldLiquidationLtv: Scalars['BigInt']['output'];
  oldMaxOriginationLtv: Scalars['BigInt']['output'];
  oldOracle: Scalars['Bytes']['output'];
  transactionHash: Scalars['Bytes']['output'];
};

export type MonoCoolerLtvOracleChange_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MonoCoolerLtvOracleChange_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  globalState?: InputMaybe<Scalars['String']['input']>;
  globalState_?: InputMaybe<MonoCoolerGlobalState_Filter>;
  globalState_contains?: InputMaybe<Scalars['String']['input']>;
  globalState_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  globalState_ends_with?: InputMaybe<Scalars['String']['input']>;
  globalState_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  globalState_gt?: InputMaybe<Scalars['String']['input']>;
  globalState_gte?: InputMaybe<Scalars['String']['input']>;
  globalState_in?: InputMaybe<Array<Scalars['String']['input']>>;
  globalState_lt?: InputMaybe<Scalars['String']['input']>;
  globalState_lte?: InputMaybe<Scalars['String']['input']>;
  globalState_not?: InputMaybe<Scalars['String']['input']>;
  globalState_not_contains?: InputMaybe<Scalars['String']['input']>;
  globalState_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  globalState_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  globalState_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  globalState_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  globalState_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  globalState_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  globalState_starts_with?: InputMaybe<Scalars['String']['input']>;
  globalState_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  newLiquidationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  newLiquidationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  newLiquidationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  newLiquidationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  newLiquidationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  newLiquidationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  newLiquidationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  newLiquidationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  newMaxOriginationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  newMaxOriginationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  newMaxOriginationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  newMaxOriginationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  newMaxOriginationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  newMaxOriginationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  newMaxOriginationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  newMaxOriginationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  newOracle?: InputMaybe<Scalars['Bytes']['input']>;
  newOracle_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newOracle_gt?: InputMaybe<Scalars['Bytes']['input']>;
  newOracle_gte?: InputMaybe<Scalars['Bytes']['input']>;
  newOracle_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  newOracle_lt?: InputMaybe<Scalars['Bytes']['input']>;
  newOracle_lte?: InputMaybe<Scalars['Bytes']['input']>;
  newOracle_not?: InputMaybe<Scalars['Bytes']['input']>;
  newOracle_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  newOracle_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  oldLiquidationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  oldLiquidationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  oldLiquidationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  oldLiquidationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  oldLiquidationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  oldLiquidationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  oldLiquidationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  oldLiquidationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  oldMaxOriginationLtv?: InputMaybe<Scalars['BigInt']['input']>;
  oldMaxOriginationLtv_gt?: InputMaybe<Scalars['BigInt']['input']>;
  oldMaxOriginationLtv_gte?: InputMaybe<Scalars['BigInt']['input']>;
  oldMaxOriginationLtv_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  oldMaxOriginationLtv_lt?: InputMaybe<Scalars['BigInt']['input']>;
  oldMaxOriginationLtv_lte?: InputMaybe<Scalars['BigInt']['input']>;
  oldMaxOriginationLtv_not?: InputMaybe<Scalars['BigInt']['input']>;
  oldMaxOriginationLtv_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  oldOracle?: InputMaybe<Scalars['Bytes']['input']>;
  oldOracle_contains?: InputMaybe<Scalars['Bytes']['input']>;
  oldOracle_gt?: InputMaybe<Scalars['Bytes']['input']>;
  oldOracle_gte?: InputMaybe<Scalars['Bytes']['input']>;
  oldOracle_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  oldOracle_lt?: InputMaybe<Scalars['Bytes']['input']>;
  oldOracle_lte?: InputMaybe<Scalars['Bytes']['input']>;
  oldOracle_not?: InputMaybe<Scalars['Bytes']['input']>;
  oldOracle_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  oldOracle_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<MonoCoolerLtvOracleChange_Filter>>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum MonoCoolerLtvOracleChange_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  GlobalState = 'globalState',
  GlobalStateBorrowsPaused = 'globalState__borrowsPaused',
  GlobalStateId = 'globalState__id',
  GlobalStateInterestAccumulatorRay = 'globalState__interestAccumulatorRay',
  GlobalStateInterestRateWad = 'globalState__interestRateWad',
  GlobalStateLiquidationPaused = 'globalState__liquidationPaused',
  GlobalStateLtvOracle = 'globalState__ltvOracle',
  GlobalStateTotalCollateral = 'globalState__totalCollateral',
  GlobalStateTotalDebt = 'globalState__totalDebt',
  GlobalStateTreasuryBorrower = 'globalState__treasuryBorrower',
  GlobalStateUpdatedAt = 'globalState__updatedAt',
  Id = 'id',
  NewLiquidationLtv = 'newLiquidationLtv',
  NewMaxOriginationLtv = 'newMaxOriginationLtv',
  NewOracle = 'newOracle',
  OldLiquidationLtv = 'oldLiquidationLtv',
  OldMaxOriginationLtv = 'oldMaxOriginationLtv',
  OldOracle = 'oldOracle',
  TransactionHash = 'transactionHash'
}

/** Aggregated LTV statistics over time */
export type MonoCoolerLtvStats = {
  __typename?: 'MonoCoolerLtvStats';
  activeAccounts: Scalars['Int']['output'];
  id: Scalars['Int8']['output'];
  liquidationLtv: Scalars['BigInt']['output'];
  maxLtv: Scalars['BigInt']['output'];
  maxOriginationLtv: Scalars['BigInt']['output'];
  minHealthFactor: Scalars['BigInt']['output'];
  minLtv: Scalars['BigInt']['output'];
  timestamp: Scalars['Timestamp']['output'];
};

export type MonoCoolerLtvStats_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MonoCoolerLtvStats_Filter>>>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  or?: InputMaybe<Array<InputMaybe<MonoCoolerLtvStats_Filter>>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum MonoCoolerLtvStats_OrderBy {
  ActiveAccounts = 'activeAccounts',
  Id = 'id',
  LiquidationLtv = 'liquidationLtv',
  MaxLtv = 'maxLtv',
  MaxOriginationLtv = 'maxOriginationLtv',
  MinHealthFactor = 'minHealthFactor',
  MinLtv = 'minLtv',
  Timestamp = 'timestamp'
}

/** Aggregated origination statistics */
export type MonoCoolerOriginationStats = {
  __typename?: 'MonoCoolerOriginationStats';
  id: Scalars['Int8']['output'];
  maxBorrowAmount: Scalars['BigInt']['output'];
  maxOriginationLtv: Scalars['BigInt']['output'];
  maxUtilization: Scalars['BigInt']['output'];
  originationCount: Scalars['Int']['output'];
  timestamp: Scalars['Timestamp']['output'];
  totalBorrowAmount: Scalars['BigInt']['output'];
};

export type MonoCoolerOriginationStats_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MonoCoolerOriginationStats_Filter>>>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  or?: InputMaybe<Array<InputMaybe<MonoCoolerOriginationStats_Filter>>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum MonoCoolerOriginationStats_OrderBy {
  Id = 'id',
  MaxBorrowAmount = 'maxBorrowAmount',
  MaxOriginationLtv = 'maxOriginationLtv',
  MaxUtilization = 'maxUtilization',
  OriginationCount = 'originationCount',
  Timestamp = 'timestamp',
  TotalBorrowAmount = 'totalBorrowAmount'
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Query = {
  __typename?: 'Query';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  borrowerStats?: Maybe<BorrowerStats>;
  borrowerStats_collection: Array<BorrowerStats>;
  claimDefaultedLoanEvent?: Maybe<ClaimDefaultedLoanEvent>;
  claimDefaultedLoanEvents: Array<ClaimDefaultedLoanEvent>;
  clearLoanRequestEvent?: Maybe<ClearLoanRequestEvent>;
  clearLoanRequestEvents: Array<ClearLoanRequestEvent>;
  clearinghouse?: Maybe<Clearinghouse>;
  clearinghouseCumulativeStats?: Maybe<ClearinghouseCumulativeStats>;
  clearinghouseCumulativeStats_collection: Array<ClearinghouseCumulativeStats>;
  clearinghouseSingleton?: Maybe<ClearinghouseSingleton>;
  clearinghouseSingletons: Array<ClearinghouseSingleton>;
  clearinghouseSnapshot?: Maybe<ClearinghouseSnapshot>;
  /** Collection of aggregated `ClearinghouseSnapshotStats` values */
  clearinghouseSnapshotStats_collection: Array<ClearinghouseSnapshotStats>;
  clearinghouseSnapshots: Array<ClearinghouseSnapshot>;
  clearinghouses: Array<Clearinghouse>;
  coolerLoan?: Maybe<CoolerLoan>;
  coolerLoanRequest?: Maybe<CoolerLoanRequest>;
  coolerLoanRequests: Array<CoolerLoanRequest>;
  coolerLoans: Array<CoolerLoan>;
  /** Collection of aggregated `DefaultStats` values */
  defaultStats_collection: Array<DefaultStats>;
  defundEvent?: Maybe<DefundEvent>;
  defundEvents: Array<DefundEvent>;
  extendLoanEvent?: Maybe<ExtendLoanEvent>;
  extendLoanEvents: Array<ExtendLoanEvent>;
  /** Collection of aggregated `ExtensionStats` values */
  extensionStats_collection: Array<ExtensionStats>;
  monoCoolerAccount?: Maybe<MonoCoolerAccount>;
  monoCoolerAccountSnapshot?: Maybe<MonoCoolerAccountSnapshot>;
  monoCoolerAccountSnapshots: Array<MonoCoolerAccountSnapshot>;
  monoCoolerAccounts: Array<MonoCoolerAccount>;
  monoCoolerActivities: Array<MonoCoolerActivity>;
  monoCoolerActivity?: Maybe<MonoCoolerActivity>;
  monoCoolerGlobalSnapshot?: Maybe<MonoCoolerGlobalSnapshot>;
  monoCoolerGlobalSnapshots: Array<MonoCoolerGlobalSnapshot>;
  monoCoolerGlobalState?: Maybe<MonoCoolerGlobalState>;
  monoCoolerGlobalStates: Array<MonoCoolerGlobalState>;
  /** Collection of aggregated `MonoCoolerGlobalStats` values */
  monoCoolerGlobalStats_collection: Array<MonoCoolerGlobalStats>;
  monoCoolerLiquidation?: Maybe<MonoCoolerLiquidation>;
  /** Collection of aggregated `MonoCoolerLiquidationStats` values */
  monoCoolerLiquidationStats_collection: Array<MonoCoolerLiquidationStats>;
  monoCoolerLiquidations: Array<MonoCoolerLiquidation>;
  monoCoolerLoanOrigination?: Maybe<MonoCoolerLoanOrigination>;
  monoCoolerLoanOriginations: Array<MonoCoolerLoanOrigination>;
  monoCoolerLtvOracleChange?: Maybe<MonoCoolerLtvOracleChange>;
  monoCoolerLtvOracleChanges: Array<MonoCoolerLtvOracleChange>;
  /** Collection of aggregated `MonoCoolerLtvStats` values */
  monoCoolerLtvStats_collection: Array<MonoCoolerLtvStats>;
  /** Collection of aggregated `MonoCoolerOriginationStats` values */
  monoCoolerOriginationStats_collection: Array<MonoCoolerOriginationStats>;
  rebalanceEvent?: Maybe<RebalanceEvent>;
  rebalanceEvents: Array<RebalanceEvent>;
  repayLoanEvent?: Maybe<RepayLoanEvent>;
  repayLoanEvents: Array<RepayLoanEvent>;
  /** Collection of aggregated `RepaymentStats` values */
  repaymentStats_collection: Array<RepaymentStats>;
  requestLoanEvent?: Maybe<RequestLoanEvent>;
  requestLoanEvents: Array<RequestLoanEvent>;
  rescindLoanRequestEvent?: Maybe<RescindLoanRequestEvent>;
  rescindLoanRequestEvents: Array<RescindLoanRequestEvent>;
};


export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type QueryBorrowerStatsArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryBorrowerStats_CollectionArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BorrowerStats_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<BorrowerStats_Filter>;
};


export type QueryClaimDefaultedLoanEventArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryClaimDefaultedLoanEventsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClaimDefaultedLoanEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ClaimDefaultedLoanEvent_Filter>;
};


export type QueryClearLoanRequestEventArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryClearLoanRequestEventsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClearLoanRequestEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ClearLoanRequestEvent_Filter>;
};


export type QueryClearinghouseArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryClearinghouseCumulativeStatsArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryClearinghouseCumulativeStats_CollectionArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClearinghouseCumulativeStats_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ClearinghouseCumulativeStats_Filter>;
};


export type QueryClearinghouseSingletonArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryClearinghouseSingletonsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClearinghouseSingleton_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ClearinghouseSingleton_Filter>;
};


export type QueryClearinghouseSnapshotArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryClearinghouseSnapshotStats_CollectionArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  interval: Aggregation_Interval;
  orderBy?: InputMaybe<ClearinghouseSnapshotStats_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ClearinghouseSnapshotStats_Filter>;
};


export type QueryClearinghouseSnapshotsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClearinghouseSnapshot_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ClearinghouseSnapshot_Filter>;
};


export type QueryClearinghousesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Clearinghouse_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Clearinghouse_Filter>;
};


export type QueryCoolerLoanArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryCoolerLoanRequestArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryCoolerLoanRequestsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CoolerLoanRequest_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<CoolerLoanRequest_Filter>;
};


export type QueryCoolerLoansArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CoolerLoan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<CoolerLoan_Filter>;
};


export type QueryDefaultStats_CollectionArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  interval: Aggregation_Interval;
  orderBy?: InputMaybe<DefaultStats_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DefaultStats_Filter>;
};


export type QueryDefundEventArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDefundEventsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DefundEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DefundEvent_Filter>;
};


export type QueryExtendLoanEventArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryExtendLoanEventsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExtendLoanEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ExtendLoanEvent_Filter>;
};


export type QueryExtensionStats_CollectionArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  interval: Aggregation_Interval;
  orderBy?: InputMaybe<ExtensionStats_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ExtensionStats_Filter>;
};


export type QueryMonoCoolerAccountArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMonoCoolerAccountSnapshotArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMonoCoolerAccountSnapshotsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerAccountSnapshot_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MonoCoolerAccountSnapshot_Filter>;
};


export type QueryMonoCoolerAccountsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerAccount_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MonoCoolerAccount_Filter>;
};


export type QueryMonoCoolerActivitiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerActivity_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MonoCoolerActivity_Filter>;
};


export type QueryMonoCoolerActivityArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMonoCoolerGlobalSnapshotArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMonoCoolerGlobalSnapshotsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerGlobalSnapshot_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MonoCoolerGlobalSnapshot_Filter>;
};


export type QueryMonoCoolerGlobalStateArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMonoCoolerGlobalStatesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerGlobalState_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MonoCoolerGlobalState_Filter>;
};


export type QueryMonoCoolerGlobalStats_CollectionArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  interval: Aggregation_Interval;
  orderBy?: InputMaybe<MonoCoolerGlobalStats_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MonoCoolerGlobalStats_Filter>;
};


export type QueryMonoCoolerLiquidationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMonoCoolerLiquidationStats_CollectionArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  interval: Aggregation_Interval;
  orderBy?: InputMaybe<MonoCoolerLiquidationStats_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MonoCoolerLiquidationStats_Filter>;
};


export type QueryMonoCoolerLiquidationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerLiquidation_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MonoCoolerLiquidation_Filter>;
};


export type QueryMonoCoolerLoanOriginationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMonoCoolerLoanOriginationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerLoanOrigination_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MonoCoolerLoanOrigination_Filter>;
};


export type QueryMonoCoolerLtvOracleChangeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMonoCoolerLtvOracleChangesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerLtvOracleChange_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MonoCoolerLtvOracleChange_Filter>;
};


export type QueryMonoCoolerLtvStats_CollectionArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  interval: Aggregation_Interval;
  orderBy?: InputMaybe<MonoCoolerLtvStats_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MonoCoolerLtvStats_Filter>;
};


export type QueryMonoCoolerOriginationStats_CollectionArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  interval: Aggregation_Interval;
  orderBy?: InputMaybe<MonoCoolerOriginationStats_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MonoCoolerOriginationStats_Filter>;
};


export type QueryRebalanceEventArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRebalanceEventsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RebalanceEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RebalanceEvent_Filter>;
};


export type QueryRepayLoanEventArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRepayLoanEventsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepayLoanEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RepayLoanEvent_Filter>;
};


export type QueryRepaymentStats_CollectionArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  interval: Aggregation_Interval;
  orderBy?: InputMaybe<RepaymentStats_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RepaymentStats_Filter>;
};


export type QueryRequestLoanEventArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRequestLoanEventsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RequestLoanEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RequestLoanEvent_Filter>;
};


export type QueryRescindLoanRequestEventArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRescindLoanRequestEventsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RescindLoanRequestEvent_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RescindLoanRequestEvent_Filter>;
};

export type RebalanceEvent = {
  __typename?: 'RebalanceEvent';
  /** Amount of reserve tokens in (positive)/out (negative) of the Clearinghouse. */
  amount: Scalars['BigDecimal']['output'];
  /** Block number at the time of the event. */
  blockNumber: Scalars['BigInt']['output'];
  /** Block timestamp at the time of the event. */
  blockTimestamp: Scalars['BigInt']['output'];
  /** The Clearinghouse that the snapshot is for. */
  clearinghouse: Clearinghouse;
  /** Event date in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /**
   * Record ID.
   *
   * In the format of `clearinghouse-blockNumber`.
   */
  id: Scalars['String']['output'];
  /** Transaction hash of the event. */
  transactionHash: Scalars['Bytes']['output'];
};

export type RebalanceEvent_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  and?: InputMaybe<Array<InputMaybe<RebalanceEvent_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  clearinghouse?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_?: InputMaybe<Clearinghouse_Filter>;
  clearinghouse_contains?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_ends_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_gt?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_gte?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clearinghouse_lt?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_lte?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_contains?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  clearinghouse_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_starts_with?: InputMaybe<Scalars['String']['input']>;
  clearinghouse_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  date_contains?: InputMaybe<Scalars['String']['input']>;
  date_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_gt?: InputMaybe<Scalars['String']['input']>;
  date_gte?: InputMaybe<Scalars['String']['input']>;
  date_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_lt?: InputMaybe<Scalars['String']['input']>;
  date_lte?: InputMaybe<Scalars['String']['input']>;
  date_not?: InputMaybe<Scalars['String']['input']>;
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  date_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<RebalanceEvent_Filter>>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum RebalanceEvent_OrderBy {
  Amount = 'amount',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Clearinghouse = 'clearinghouse',
  ClearinghouseAddress = 'clearinghouse__address',
  ClearinghouseCollateralToken = 'clearinghouse__collateralToken',
  ClearinghouseCollateralTokenDecimals = 'clearinghouse__collateralTokenDecimals',
  ClearinghouseCoolerFactoryAddress = 'clearinghouse__coolerFactoryAddress',
  ClearinghouseCreatedBlock = 'clearinghouse__createdBlock',
  ClearinghouseCreatedTimestamp = 'clearinghouse__createdTimestamp',
  ClearinghouseDuration = 'clearinghouse__duration',
  ClearinghouseFundAmount = 'clearinghouse__fundAmount',
  ClearinghouseFundCadence = 'clearinghouse__fundCadence',
  ClearinghouseId = 'clearinghouse__id',
  ClearinghouseInterestRate = 'clearinghouse__interestRate',
  ClearinghouseLoanToCollateral = 'clearinghouse__loanToCollateral',
  ClearinghouseReserveToken = 'clearinghouse__reserveToken',
  ClearinghouseReserveTokenDecimals = 'clearinghouse__reserveTokenDecimals',
  ClearinghouseSReserveToken = 'clearinghouse__sReserveToken',
  ClearinghouseSReserveTokenDecimals = 'clearinghouse__sReserveTokenDecimals',
  ClearinghouseVersion = 'clearinghouse__version',
  Date = 'date',
  Id = 'id',
  TransactionHash = 'transactionHash'
}

export type RepayLoanEvent = {
  __typename?: 'RepayLoanEvent';
  /** Amount paid. */
  amountPaid: Scalars['BigDecimal']['output'];
  /** Block number at the time of the event. */
  blockNumber: Scalars['BigInt']['output'];
  /** Block timestamp at the time of the event. */
  blockTimestamp: Scalars['BigInt']['output'];
  /** Event date in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /**
   * Record ID.
   *
   * In the format of `cooler-loanId`.
   */
  id: Scalars['Int8']['output'];
  /** Amount of interest paid in this repayment */
  interestPaid: Scalars['BigDecimal']['output'];
  /** Loan that was repaid. */
  loan: CoolerLoan;
  /** Amount of principal paid in this repayment */
  principalPaid: Scalars['BigDecimal']['output'];
  /** Seconds to expiry. */
  secondsToExpiry: Scalars['BigInt']['output'];
  /** Timestamp of the event. */
  timestamp: Scalars['Timestamp']['output'];
  /** Transaction hash of the event. */
  transactionHash: Scalars['Bytes']['output'];
};

export type RepayLoanEvent_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountPaid?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountPaid_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  and?: InputMaybe<Array<InputMaybe<RepayLoanEvent_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  date_contains?: InputMaybe<Scalars['String']['input']>;
  date_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_gt?: InputMaybe<Scalars['String']['input']>;
  date_gte?: InputMaybe<Scalars['String']['input']>;
  date_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_lt?: InputMaybe<Scalars['String']['input']>;
  date_lte?: InputMaybe<Scalars['String']['input']>;
  date_not?: InputMaybe<Scalars['String']['input']>;
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  date_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  id_not?: InputMaybe<Scalars['Int8']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  interestPaid?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestPaid_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestPaid_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestPaid_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  interestPaid_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestPaid_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestPaid_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  interestPaid_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<CoolerLoan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<RepayLoanEvent_Filter>>>;
  principalPaid?: InputMaybe<Scalars['BigDecimal']['input']>;
  principalPaid_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  principalPaid_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  principalPaid_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  principalPaid_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  principalPaid_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  principalPaid_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  principalPaid_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  secondsToExpiry?: InputMaybe<Scalars['BigInt']['input']>;
  secondsToExpiry_gt?: InputMaybe<Scalars['BigInt']['input']>;
  secondsToExpiry_gte?: InputMaybe<Scalars['BigInt']['input']>;
  secondsToExpiry_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  secondsToExpiry_lt?: InputMaybe<Scalars['BigInt']['input']>;
  secondsToExpiry_lte?: InputMaybe<Scalars['BigInt']['input']>;
  secondsToExpiry_not?: InputMaybe<Scalars['BigInt']['input']>;
  secondsToExpiry_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum RepayLoanEvent_OrderBy {
  AmountPaid = 'amountPaid',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Date = 'date',
  Id = 'id',
  InterestPaid = 'interestPaid',
  Loan = 'loan',
  LoanCollateral = 'loan__collateral',
  LoanCooler = 'loan__cooler',
  LoanCreatedBlock = 'loan__createdBlock',
  LoanCreatedTimestamp = 'loan__createdTimestamp',
  LoanCreatedTransaction = 'loan__createdTransaction',
  LoanCurrentExpiryTimestamp = 'loan__currentExpiryTimestamp',
  LoanHasCallback = 'loan__hasCallback',
  LoanId = 'loan__id',
  LoanInterest = 'loan__interest',
  LoanLoanId = 'loan__loanId',
  LoanOriginalExpiryTimestamp = 'loan__originalExpiryTimestamp',
  LoanPrincipal = 'loan__principal',
  PrincipalPaid = 'principalPaid',
  SecondsToExpiry = 'secondsToExpiry',
  Timestamp = 'timestamp',
  TransactionHash = 'transactionHash'
}

/** Aggregated repayment statistics */
export type RepaymentStats = {
  __typename?: 'RepaymentStats';
  clearinghouse: Scalars['BigInt']['output'];
  id: Scalars['Int8']['output'];
  maxAmountPaid: Scalars['BigDecimal']['output'];
  maxInterestPaid: Scalars['BigDecimal']['output'];
  maxPrincipalPaid: Scalars['BigDecimal']['output'];
  minAmountPaid: Scalars['BigDecimal']['output'];
  minInterestPaid: Scalars['BigDecimal']['output'];
  minPrincipalPaid: Scalars['BigDecimal']['output'];
  repaymentCount: Scalars['Int']['output'];
  timestamp: Scalars['Timestamp']['output'];
  totalAmountPaid: Scalars['BigDecimal']['output'];
  totalInterestPaid: Scalars['BigDecimal']['output'];
  totalPrincipalPaid: Scalars['BigDecimal']['output'];
};

export type RepaymentStats_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<RepaymentStats_Filter>>>;
  id?: InputMaybe<Scalars['Int8']['input']>;
  id_gt?: InputMaybe<Scalars['Int8']['input']>;
  id_gte?: InputMaybe<Scalars['Int8']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int8']['input']>>;
  id_lt?: InputMaybe<Scalars['Int8']['input']>;
  id_lte?: InputMaybe<Scalars['Int8']['input']>;
  or?: InputMaybe<Array<InputMaybe<RepaymentStats_Filter>>>;
  timestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Timestamp']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum RepaymentStats_OrderBy {
  Clearinghouse = 'clearinghouse',
  Id = 'id',
  MaxAmountPaid = 'maxAmountPaid',
  MaxInterestPaid = 'maxInterestPaid',
  MaxPrincipalPaid = 'maxPrincipalPaid',
  MinAmountPaid = 'minAmountPaid',
  MinInterestPaid = 'minInterestPaid',
  MinPrincipalPaid = 'minPrincipalPaid',
  RepaymentCount = 'repaymentCount',
  Timestamp = 'timestamp',
  TotalAmountPaid = 'totalAmountPaid',
  TotalInterestPaid = 'totalInterestPaid',
  TotalPrincipalPaid = 'totalPrincipalPaid'
}

export type RequestLoanEvent = {
  __typename?: 'RequestLoanEvent';
  /** Block number at the time of the event. */
  blockNumber: Scalars['BigInt']['output'];
  /** Block timestamp at the time of the event. */
  blockTimestamp: Scalars['BigInt']['output'];
  /** Event date in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /**
   * Record ID.
   *
   * In the format of `cooler-requestId`.
   */
  id: Scalars['String']['output'];
  /** Request that created the loan. */
  request: CoolerLoanRequest;
  /** Transaction hash of the event. */
  transactionHash: Scalars['Bytes']['output'];
};

export type RequestLoanEvent_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<RequestLoanEvent_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  date_contains?: InputMaybe<Scalars['String']['input']>;
  date_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_gt?: InputMaybe<Scalars['String']['input']>;
  date_gte?: InputMaybe<Scalars['String']['input']>;
  date_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_lt?: InputMaybe<Scalars['String']['input']>;
  date_lte?: InputMaybe<Scalars['String']['input']>;
  date_not?: InputMaybe<Scalars['String']['input']>;
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  date_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<RequestLoanEvent_Filter>>>;
  request?: InputMaybe<Scalars['String']['input']>;
  request_?: InputMaybe<CoolerLoanRequest_Filter>;
  request_contains?: InputMaybe<Scalars['String']['input']>;
  request_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  request_ends_with?: InputMaybe<Scalars['String']['input']>;
  request_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  request_gt?: InputMaybe<Scalars['String']['input']>;
  request_gte?: InputMaybe<Scalars['String']['input']>;
  request_in?: InputMaybe<Array<Scalars['String']['input']>>;
  request_lt?: InputMaybe<Scalars['String']['input']>;
  request_lte?: InputMaybe<Scalars['String']['input']>;
  request_not?: InputMaybe<Scalars['String']['input']>;
  request_not_contains?: InputMaybe<Scalars['String']['input']>;
  request_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  request_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  request_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  request_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  request_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  request_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  request_starts_with?: InputMaybe<Scalars['String']['input']>;
  request_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum RequestLoanEvent_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Date = 'date',
  Id = 'id',
  Request = 'request',
  RequestAmount = 'request__amount',
  RequestBorrower = 'request__borrower',
  RequestCollateralToken = 'request__collateralToken',
  RequestCooler = 'request__cooler',
  RequestCreatedBlock = 'request__createdBlock',
  RequestCreatedTimestamp = 'request__createdTimestamp',
  RequestCreatedTransaction = 'request__createdTransaction',
  RequestDebtToken = 'request__debtToken',
  RequestDurationSeconds = 'request__durationSeconds',
  RequestId = 'request__id',
  RequestInterestPercentage = 'request__interestPercentage',
  RequestIsRescinded = 'request__isRescinded',
  RequestLoanToCollateralRatio = 'request__loanToCollateralRatio',
  RequestRequestId = 'request__requestId',
  TransactionHash = 'transactionHash'
}

export type RescindLoanRequestEvent = {
  __typename?: 'RescindLoanRequestEvent';
  /** Block number at the time of the event. */
  blockNumber: Scalars['BigInt']['output'];
  /** Block timestamp at the time of the event. */
  blockTimestamp: Scalars['BigInt']['output'];
  /** Event date in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /**
   * Record ID.
   *
   * In the format of `cooler-requestId`.
   */
  id: Scalars['String']['output'];
  /** Request that was rescinded. */
  request: CoolerLoanRequest;
  /** Transaction hash of the event. */
  transactionHash: Scalars['Bytes']['output'];
};

export type RescindLoanRequestEvent_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<RescindLoanRequestEvent_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  date_contains?: InputMaybe<Scalars['String']['input']>;
  date_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_gt?: InputMaybe<Scalars['String']['input']>;
  date_gte?: InputMaybe<Scalars['String']['input']>;
  date_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_lt?: InputMaybe<Scalars['String']['input']>;
  date_lte?: InputMaybe<Scalars['String']['input']>;
  date_not?: InputMaybe<Scalars['String']['input']>;
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  date_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  date_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  date_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id_starts_with?: InputMaybe<Scalars['String']['input']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<RescindLoanRequestEvent_Filter>>>;
  request?: InputMaybe<Scalars['String']['input']>;
  request_?: InputMaybe<CoolerLoanRequest_Filter>;
  request_contains?: InputMaybe<Scalars['String']['input']>;
  request_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  request_ends_with?: InputMaybe<Scalars['String']['input']>;
  request_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  request_gt?: InputMaybe<Scalars['String']['input']>;
  request_gte?: InputMaybe<Scalars['String']['input']>;
  request_in?: InputMaybe<Array<Scalars['String']['input']>>;
  request_lt?: InputMaybe<Scalars['String']['input']>;
  request_lte?: InputMaybe<Scalars['String']['input']>;
  request_not?: InputMaybe<Scalars['String']['input']>;
  request_not_contains?: InputMaybe<Scalars['String']['input']>;
  request_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  request_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  request_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  request_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  request_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  request_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  request_starts_with?: InputMaybe<Scalars['String']['input']>;
  request_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transactionHash?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum RescindLoanRequestEvent_OrderBy {
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Date = 'date',
  Id = 'id',
  Request = 'request',
  RequestAmount = 'request__amount',
  RequestBorrower = 'request__borrower',
  RequestCollateralToken = 'request__collateralToken',
  RequestCooler = 'request__cooler',
  RequestCreatedBlock = 'request__createdBlock',
  RequestCreatedTimestamp = 'request__createdTimestamp',
  RequestCreatedTransaction = 'request__createdTransaction',
  RequestDebtToken = 'request__debtToken',
  RequestDurationSeconds = 'request__durationSeconds',
  RequestId = 'request__id',
  RequestInterestPercentage = 'request__interestPercentage',
  RequestIsRescinded = 'request__isRescinded',
  RequestLoanToCollateralRatio = 'request__loanToCollateralRatio',
  RequestRequestId = 'request__requestId',
  TransactionHash = 'transactionHash'
}

export type _Block_ = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']['output']>;
  /** The block number */
  number: Scalars['Int']['output'];
  /** The hash of the parent block */
  parentHash?: Maybe<Scalars['Bytes']['output']>;
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']['output']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String']['output'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean']['output'];
};

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}

export type BorrowersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BorrowersQuery = { __typename?: 'Query', borrowerStats_collection: Array<{ __typename?: 'BorrowerStats', currentInterestDue: any, currentCollateral: any, currentBorrowed: any, borrower: any, activeLoans: number, maxActiveLoans: number, maxBorrowedValue: any, totalDefaultedLoans: number, totalLoanExtensions: number, totalLoans: number, totalRepaidLoans: number, loans: Array<{ __typename?: 'CoolerLoan', id: string }> }> };

export type ClearinghousesQueryVariables = Exact<{ [key: string]: never; }>;


export type ClearinghousesQuery = { __typename?: 'Query', clearinghouses: Array<{ __typename?: 'Clearinghouse', address: any }> };

export type UtilizationQueryVariables = Exact<{
  clearinghouseAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type UtilizationQuery = { __typename?: 'Query', clearinghouseSnapshotStats_collection: Array<{ __typename?: 'ClearinghouseSnapshotStats', timestamp: any, totalPrincipalReceivables: any, totalInterestReceivables: any, sReserveInReserveBalance: any, treasurySReserveInReserveBalance: any, treasuryReserveBalance: any, reserveBalance: any, clearinghouse: { __typename?: 'Clearinghouse', address: any } }> };

export type ClearinghouseStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClearinghouseStatsQuery = { __typename?: 'Query', clearinghouseCumulativeStats_collection: Array<{ __typename?: 'ClearinghouseCumulativeStats', currentActiveBorrowers: number, lastUpdateTimestamp: any, totalLoans: number, totalRepaidLoans: number, totalDefaultedLoans: number, totalUniqueBorrowers: number, currentActiveLoans: number, totalLoopers: number, currentActiveLoopers: number }> };

export type GetDefaultedLoansQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDefaultedLoansQuery = { __typename?: 'Query', coolerLoans: Array<{ __typename?: 'CoolerLoan', id: string, loanId: any, cooler: any, currentExpiryTimestamp: any, borrower: { __typename?: 'BorrowerStats', id: string }, defaultedClaimEvents: Array<{ __typename?: 'ClaimDefaultedLoanEvent', defaultedPrincipal: any, collateralValueClaimed: any, collateralQuantityClaimed: any }> }> };

export type MonoCoolerAccountsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MonoCoolerAccount_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
}>;


export type MonoCoolerAccountsQuery = { __typename?: 'Query', monoCoolerAccounts: Array<{ __typename?: 'MonoCoolerAccount', id: string, address: any, collateral: any, debt: any, ltv: any, healthFactor: any, updatedAt: any }> };

export type MonoCoolerAtRiskAccountsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  healthFactorThreshold?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type MonoCoolerAtRiskAccountsQuery = { __typename?: 'Query', monoCoolerAccounts: Array<{ __typename?: 'MonoCoolerAccount', id: string, address: any, collateral: any, debt: any, ltv: any, healthFactor: any, updatedAt: any }> };

export type MonoCoolerRecentActivityQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MonoCoolerRecentActivityQuery = { __typename?: 'Query', monoCoolerActivities: Array<{ __typename?: 'MonoCoolerActivity', id: string, type: string, amount: any, collateral?: any | null, debt?: any | null, txHash: any, timestamp: any, account: { __typename?: 'MonoCoolerAccount', address: any } }> };

export type MonoCoolerLiquidationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MonoCoolerLiquidationsQuery = { __typename?: 'Query', monoCoolerActivities: Array<{ __typename?: 'MonoCoolerActivity', id: string, type: string, amount: any, collateral?: any | null, debt?: any | null, txHash: any, timestamp: any, account: { __typename?: 'MonoCoolerAccount', address: any } }> };

export type MonoCoolerActivityByTypeQueryVariables = Exact<{
  type: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MonoCoolerActivityByTypeQuery = { __typename?: 'Query', monoCoolerActivities: Array<{ __typename?: 'MonoCoolerActivity', id: string, type: string, amount: any, collateral?: any | null, debt?: any | null, txHash: any, timestamp: any, account: { __typename?: 'MonoCoolerAccount', address: any } }> };

export type MonoCoolerGlobalStateQueryVariables = Exact<{ [key: string]: never; }>;


export type MonoCoolerGlobalStateQuery = { __typename?: 'Query', monoCoolerGlobalStates: Array<{ __typename?: 'MonoCoolerGlobalState', id: string, totalCollateral: any, totalDebt: any, interestAccumulatorRay: any, interestRateWad: any, ltvOracle: any, liquidationPaused: boolean, borrowsPaused: boolean, treasuryBorrower: any, updatedAt: any }> };

export type MonoCoolerHistoricalDataQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MonoCoolerHistoricalDataQuery = { __typename?: 'Query', monoCoolerGlobalSnapshots: Array<{ __typename?: 'MonoCoolerGlobalSnapshot', id: any, timestamp: any, totalCollateral: any, totalDebt: any, interestRateWad: any }> };

export type ProtocolIncomeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProtocolIncomeQuery = { __typename?: 'Query', defaultStats_collection: Array<{ __typename?: 'DefaultStats', totalCollateralClaimed: any, totalValueClaimed: any, totalPrincipalDefaulted: any, timestamp: any }>, extensionStats_collection: Array<{ __typename?: 'ExtensionStats', totalNewInterest: any, timestamp: any }>, repaymentStats_collection: Array<{ __typename?: 'RepaymentStats', timestamp: any, totalInterestPaid: any }> };

export type TopBorrowQueryVariables = Exact<{ [key: string]: never; }>;


export type TopBorrowQuery = { __typename?: 'Query', clearLoanRequestEvents: Array<{ __typename?: 'ClearLoanRequestEvent', loan: { __typename?: 'CoolerLoan', principal: any } }> };

export type TopLooperQueryVariables = Exact<{ [key: string]: never; }>;


export type TopLooperQuery = { __typename?: 'Query', borrowerStats_collection: Array<{ __typename?: 'BorrowerStats', maxActiveLoans: number, totalLoans: number, activeLoans: number }> };

export type TopTotalBorrowsQueryVariables = Exact<{ [key: string]: never; }>;


export type TopTotalBorrowsQuery = { __typename?: 'Query', borrowerStats_collection: Array<{ __typename?: 'BorrowerStats', maxBorrowedValue: any }> };

export type GetActiveLoansByMaturityQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  principal?: InputMaybe<Scalars['BigDecimal']['input']>;
  date?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type GetActiveLoansByMaturityQuery = { __typename?: 'Query', coolerLoans: Array<{ __typename?: 'CoolerLoan', id: string, cooler: any, principal: any, currentExpiryTimestamp: any, interest: any, collateral: any, loanId: any, borrower: { __typename?: 'BorrowerStats', id: string }, defaultedClaimEvents: Array<{ __typename?: 'ClaimDefaultedLoanEvent', collateralPrice: any }>, extendEvents: Array<{ __typename?: 'ExtendLoanEvent', expiryTimestamp: any }> }> };



export const BorrowersDocument = `
    query Borrowers($first: Int = 1000, $skip: Int = 0) {
  borrowerStats_collection(
    orderBy: lastUpdateTimestamp
    first: $first
    skip: $skip
  ) {
    loans {
      id
    }
    currentInterestDue
    currentCollateral
    currentBorrowed
    borrower
    activeLoans
    maxActiveLoans
    maxBorrowedValue
    totalDefaultedLoans
    totalLoanExtensions
    totalLoans
    totalRepaidLoans
  }
}
    `;

export const useBorrowersQuery = <
      TData = BorrowersQuery,
      TError = unknown
    >(
      variables?: BorrowersQueryVariables,
      options?: Omit<UseQueryOptions<BorrowersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BorrowersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BorrowersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Borrowers'] : ['Borrowers', variables],
    queryFn: fetcher<BorrowersQuery, BorrowersQueryVariables>(BorrowersDocument, variables),
    ...options
  }
    )};

useBorrowersQuery.getKey = (variables?: BorrowersQueryVariables) => variables === undefined ? ['Borrowers'] : ['Borrowers', variables];

export const useInfiniteBorrowersQuery = <
      TData = InfiniteData<BorrowersQuery>,
      TError = unknown
    >(
      variables: BorrowersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BorrowersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BorrowersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<BorrowersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Borrowers.infinite'] : ['Borrowers.infinite', variables],
      queryFn: (metaData) => fetcher<BorrowersQuery, BorrowersQueryVariables>(BorrowersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteBorrowersQuery.getKey = (variables?: BorrowersQueryVariables) => variables === undefined ? ['Borrowers.infinite'] : ['Borrowers.infinite', variables];


useBorrowersQuery.fetcher = (variables?: BorrowersQueryVariables) => fetcher<BorrowersQuery, BorrowersQueryVariables>(BorrowersDocument, variables);

export const ClearinghousesDocument = `
    query Clearinghouses {
  clearinghouses {
    address
  }
}
    `;

export const useClearinghousesQuery = <
      TData = ClearinghousesQuery,
      TError = unknown
    >(
      variables?: ClearinghousesQueryVariables,
      options?: Omit<UseQueryOptions<ClearinghousesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClearinghousesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClearinghousesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Clearinghouses'] : ['Clearinghouses', variables],
    queryFn: fetcher<ClearinghousesQuery, ClearinghousesQueryVariables>(ClearinghousesDocument, variables),
    ...options
  }
    )};

useClearinghousesQuery.getKey = (variables?: ClearinghousesQueryVariables) => variables === undefined ? ['Clearinghouses'] : ['Clearinghouses', variables];

export const useInfiniteClearinghousesQuery = <
      TData = InfiniteData<ClearinghousesQuery>,
      TError = unknown
    >(
      variables: ClearinghousesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClearinghousesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClearinghousesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClearinghousesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Clearinghouses.infinite'] : ['Clearinghouses.infinite', variables],
      queryFn: (metaData) => fetcher<ClearinghousesQuery, ClearinghousesQueryVariables>(ClearinghousesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClearinghousesQuery.getKey = (variables?: ClearinghousesQueryVariables) => variables === undefined ? ['Clearinghouses.infinite'] : ['Clearinghouses.infinite', variables];


useClearinghousesQuery.fetcher = (variables?: ClearinghousesQueryVariables) => fetcher<ClearinghousesQuery, ClearinghousesQueryVariables>(ClearinghousesDocument, variables);

export const UtilizationDocument = `
    query Utilization($clearinghouseAddress: String) {
  clearinghouseSnapshotStats_collection(
    first: 1000
    interval: day
    where: {clearinghouse: $clearinghouseAddress}
  ) {
    timestamp
    clearinghouse {
      address
    }
    totalPrincipalReceivables
    totalInterestReceivables
    sReserveInReserveBalance
    treasurySReserveInReserveBalance
    treasuryReserveBalance
    reserveBalance
  }
}
    `;

export const useUtilizationQuery = <
      TData = UtilizationQuery,
      TError = unknown
    >(
      variables?: UtilizationQueryVariables,
      options?: Omit<UseQueryOptions<UtilizationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UtilizationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UtilizationQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Utilization'] : ['Utilization', variables],
    queryFn: fetcher<UtilizationQuery, UtilizationQueryVariables>(UtilizationDocument, variables),
    ...options
  }
    )};

useUtilizationQuery.getKey = (variables?: UtilizationQueryVariables) => variables === undefined ? ['Utilization'] : ['Utilization', variables];

export const useInfiniteUtilizationQuery = <
      TData = InfiniteData<UtilizationQuery>,
      TError = unknown
    >(
      variables: UtilizationQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UtilizationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UtilizationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UtilizationQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Utilization.infinite'] : ['Utilization.infinite', variables],
      queryFn: (metaData) => fetcher<UtilizationQuery, UtilizationQueryVariables>(UtilizationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUtilizationQuery.getKey = (variables?: UtilizationQueryVariables) => variables === undefined ? ['Utilization.infinite'] : ['Utilization.infinite', variables];


useUtilizationQuery.fetcher = (variables?: UtilizationQueryVariables) => fetcher<UtilizationQuery, UtilizationQueryVariables>(UtilizationDocument, variables);

export const ClearinghouseStatsDocument = `
    query ClearinghouseStats {
  clearinghouseCumulativeStats_collection {
    currentActiveBorrowers
    lastUpdateTimestamp
    totalLoans
    totalRepaidLoans
    totalDefaultedLoans
    totalUniqueBorrowers
    currentActiveLoans
    totalLoopers
    currentActiveLoopers
  }
}
    `;

export const useClearinghouseStatsQuery = <
      TData = ClearinghouseStatsQuery,
      TError = unknown
    >(
      variables?: ClearinghouseStatsQueryVariables,
      options?: Omit<UseQueryOptions<ClearinghouseStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClearinghouseStatsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClearinghouseStatsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ClearinghouseStats'] : ['ClearinghouseStats', variables],
    queryFn: fetcher<ClearinghouseStatsQuery, ClearinghouseStatsQueryVariables>(ClearinghouseStatsDocument, variables),
    ...options
  }
    )};

useClearinghouseStatsQuery.getKey = (variables?: ClearinghouseStatsQueryVariables) => variables === undefined ? ['ClearinghouseStats'] : ['ClearinghouseStats', variables];

export const useInfiniteClearinghouseStatsQuery = <
      TData = InfiniteData<ClearinghouseStatsQuery>,
      TError = unknown
    >(
      variables: ClearinghouseStatsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClearinghouseStatsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClearinghouseStatsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClearinghouseStatsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ClearinghouseStats.infinite'] : ['ClearinghouseStats.infinite', variables],
      queryFn: (metaData) => fetcher<ClearinghouseStatsQuery, ClearinghouseStatsQueryVariables>(ClearinghouseStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClearinghouseStatsQuery.getKey = (variables?: ClearinghouseStatsQueryVariables) => variables === undefined ? ['ClearinghouseStats.infinite'] : ['ClearinghouseStats.infinite', variables];


useClearinghouseStatsQuery.fetcher = (variables?: ClearinghouseStatsQueryVariables) => fetcher<ClearinghouseStatsQuery, ClearinghouseStatsQueryVariables>(ClearinghouseStatsDocument, variables);

export const GetDefaultedLoansDocument = `
    query GetDefaultedLoans($first: Int = 1000, $skip: Int = 0) {
  coolerLoans(
    first: $first
    skip: $skip
    orderBy: currentExpiryTimestamp
    orderDirection: asc
    where: {defaultedClaimEvents_: {id_not: null}}
  ) {
    id
    borrower {
      id
    }
    loanId
    cooler
    currentExpiryTimestamp
    defaultedClaimEvents {
      defaultedPrincipal
      collateralValueClaimed
      collateralQuantityClaimed
    }
  }
}
    `;

export const useGetDefaultedLoansQuery = <
      TData = GetDefaultedLoansQuery,
      TError = unknown
    >(
      variables?: GetDefaultedLoansQueryVariables,
      options?: Omit<UseQueryOptions<GetDefaultedLoansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetDefaultedLoansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetDefaultedLoansQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetDefaultedLoans'] : ['GetDefaultedLoans', variables],
    queryFn: fetcher<GetDefaultedLoansQuery, GetDefaultedLoansQueryVariables>(GetDefaultedLoansDocument, variables),
    ...options
  }
    )};

useGetDefaultedLoansQuery.getKey = (variables?: GetDefaultedLoansQueryVariables) => variables === undefined ? ['GetDefaultedLoans'] : ['GetDefaultedLoans', variables];

export const useInfiniteGetDefaultedLoansQuery = <
      TData = InfiniteData<GetDefaultedLoansQuery>,
      TError = unknown
    >(
      variables: GetDefaultedLoansQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetDefaultedLoansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetDefaultedLoansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetDefaultedLoansQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetDefaultedLoans.infinite'] : ['GetDefaultedLoans.infinite', variables],
      queryFn: (metaData) => fetcher<GetDefaultedLoansQuery, GetDefaultedLoansQueryVariables>(GetDefaultedLoansDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetDefaultedLoansQuery.getKey = (variables?: GetDefaultedLoansQueryVariables) => variables === undefined ? ['GetDefaultedLoans.infinite'] : ['GetDefaultedLoans.infinite', variables];


useGetDefaultedLoansQuery.fetcher = (variables?: GetDefaultedLoansQueryVariables) => fetcher<GetDefaultedLoansQuery, GetDefaultedLoansQueryVariables>(GetDefaultedLoansDocument, variables);

export const MonoCoolerAccountsDocument = `
    query MonoCoolerAccounts($first: Int = 100, $orderBy: MonoCoolerAccount_orderBy = healthFactor, $orderDirection: OrderDirection = asc) {
  monoCoolerAccounts(
    first: $first
    orderBy: $orderBy
    orderDirection: $orderDirection
  ) {
    id
    address
    collateral
    debt
    ltv
    healthFactor
    updatedAt
  }
}
    `;

export const useMonoCoolerAccountsQuery = <
      TData = MonoCoolerAccountsQuery,
      TError = unknown
    >(
      variables?: MonoCoolerAccountsQueryVariables,
      options?: Omit<UseQueryOptions<MonoCoolerAccountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MonoCoolerAccountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MonoCoolerAccountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MonoCoolerAccounts'] : ['MonoCoolerAccounts', variables],
    queryFn: fetcher<MonoCoolerAccountsQuery, MonoCoolerAccountsQueryVariables>(MonoCoolerAccountsDocument, variables),
    ...options
  }
    )};

useMonoCoolerAccountsQuery.getKey = (variables?: MonoCoolerAccountsQueryVariables) => variables === undefined ? ['MonoCoolerAccounts'] : ['MonoCoolerAccounts', variables];

export const useInfiniteMonoCoolerAccountsQuery = <
      TData = InfiniteData<MonoCoolerAccountsQuery>,
      TError = unknown
    >(
      variables: MonoCoolerAccountsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MonoCoolerAccountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MonoCoolerAccountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MonoCoolerAccountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MonoCoolerAccounts.infinite'] : ['MonoCoolerAccounts.infinite', variables],
      queryFn: (metaData) => fetcher<MonoCoolerAccountsQuery, MonoCoolerAccountsQueryVariables>(MonoCoolerAccountsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMonoCoolerAccountsQuery.getKey = (variables?: MonoCoolerAccountsQueryVariables) => variables === undefined ? ['MonoCoolerAccounts.infinite'] : ['MonoCoolerAccounts.infinite', variables];


useMonoCoolerAccountsQuery.fetcher = (variables?: MonoCoolerAccountsQueryVariables) => fetcher<MonoCoolerAccountsQuery, MonoCoolerAccountsQueryVariables>(MonoCoolerAccountsDocument, variables);

export const MonoCoolerAtRiskAccountsDocument = `
    query MonoCoolerAtRiskAccounts($first: Int = 20, $healthFactorThreshold: BigInt = "1200000000000000000") {
  monoCoolerAccounts(
    first: $first
    where: {healthFactor_lt: $healthFactorThreshold}
    orderBy: healthFactor
    orderDirection: asc
  ) {
    id
    address
    collateral
    debt
    ltv
    healthFactor
    updatedAt
  }
}
    `;

export const useMonoCoolerAtRiskAccountsQuery = <
      TData = MonoCoolerAtRiskAccountsQuery,
      TError = unknown
    >(
      variables?: MonoCoolerAtRiskAccountsQueryVariables,
      options?: Omit<UseQueryOptions<MonoCoolerAtRiskAccountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MonoCoolerAtRiskAccountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MonoCoolerAtRiskAccountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MonoCoolerAtRiskAccounts'] : ['MonoCoolerAtRiskAccounts', variables],
    queryFn: fetcher<MonoCoolerAtRiskAccountsQuery, MonoCoolerAtRiskAccountsQueryVariables>(MonoCoolerAtRiskAccountsDocument, variables),
    ...options
  }
    )};

useMonoCoolerAtRiskAccountsQuery.getKey = (variables?: MonoCoolerAtRiskAccountsQueryVariables) => variables === undefined ? ['MonoCoolerAtRiskAccounts'] : ['MonoCoolerAtRiskAccounts', variables];

export const useInfiniteMonoCoolerAtRiskAccountsQuery = <
      TData = InfiniteData<MonoCoolerAtRiskAccountsQuery>,
      TError = unknown
    >(
      variables: MonoCoolerAtRiskAccountsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MonoCoolerAtRiskAccountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MonoCoolerAtRiskAccountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MonoCoolerAtRiskAccountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MonoCoolerAtRiskAccounts.infinite'] : ['MonoCoolerAtRiskAccounts.infinite', variables],
      queryFn: (metaData) => fetcher<MonoCoolerAtRiskAccountsQuery, MonoCoolerAtRiskAccountsQueryVariables>(MonoCoolerAtRiskAccountsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMonoCoolerAtRiskAccountsQuery.getKey = (variables?: MonoCoolerAtRiskAccountsQueryVariables) => variables === undefined ? ['MonoCoolerAtRiskAccounts.infinite'] : ['MonoCoolerAtRiskAccounts.infinite', variables];


useMonoCoolerAtRiskAccountsQuery.fetcher = (variables?: MonoCoolerAtRiskAccountsQueryVariables) => fetcher<MonoCoolerAtRiskAccountsQuery, MonoCoolerAtRiskAccountsQueryVariables>(MonoCoolerAtRiskAccountsDocument, variables);

export const MonoCoolerRecentActivityDocument = `
    query MonoCoolerRecentActivity($first: Int = 50) {
  monoCoolerActivities(first: $first, orderBy: timestamp, orderDirection: desc) {
    id
    type
    account {
      address
    }
    amount
    collateral
    debt
    txHash
    timestamp
  }
}
    `;

export const useMonoCoolerRecentActivityQuery = <
      TData = MonoCoolerRecentActivityQuery,
      TError = unknown
    >(
      variables?: MonoCoolerRecentActivityQueryVariables,
      options?: Omit<UseQueryOptions<MonoCoolerRecentActivityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MonoCoolerRecentActivityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MonoCoolerRecentActivityQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MonoCoolerRecentActivity'] : ['MonoCoolerRecentActivity', variables],
    queryFn: fetcher<MonoCoolerRecentActivityQuery, MonoCoolerRecentActivityQueryVariables>(MonoCoolerRecentActivityDocument, variables),
    ...options
  }
    )};

useMonoCoolerRecentActivityQuery.getKey = (variables?: MonoCoolerRecentActivityQueryVariables) => variables === undefined ? ['MonoCoolerRecentActivity'] : ['MonoCoolerRecentActivity', variables];

export const useInfiniteMonoCoolerRecentActivityQuery = <
      TData = InfiniteData<MonoCoolerRecentActivityQuery>,
      TError = unknown
    >(
      variables: MonoCoolerRecentActivityQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MonoCoolerRecentActivityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MonoCoolerRecentActivityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MonoCoolerRecentActivityQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MonoCoolerRecentActivity.infinite'] : ['MonoCoolerRecentActivity.infinite', variables],
      queryFn: (metaData) => fetcher<MonoCoolerRecentActivityQuery, MonoCoolerRecentActivityQueryVariables>(MonoCoolerRecentActivityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMonoCoolerRecentActivityQuery.getKey = (variables?: MonoCoolerRecentActivityQueryVariables) => variables === undefined ? ['MonoCoolerRecentActivity.infinite'] : ['MonoCoolerRecentActivity.infinite', variables];


useMonoCoolerRecentActivityQuery.fetcher = (variables?: MonoCoolerRecentActivityQueryVariables) => fetcher<MonoCoolerRecentActivityQuery, MonoCoolerRecentActivityQueryVariables>(MonoCoolerRecentActivityDocument, variables);

export const MonoCoolerLiquidationsDocument = `
    query MonoCoolerLiquidations($first: Int = 20) {
  monoCoolerActivities(
    first: $first
    where: {type: "liquidation"}
    orderBy: timestamp
    orderDirection: desc
  ) {
    id
    type
    account {
      address
    }
    amount
    collateral
    debt
    txHash
    timestamp
  }
}
    `;

export const useMonoCoolerLiquidationsQuery = <
      TData = MonoCoolerLiquidationsQuery,
      TError = unknown
    >(
      variables?: MonoCoolerLiquidationsQueryVariables,
      options?: Omit<UseQueryOptions<MonoCoolerLiquidationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MonoCoolerLiquidationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MonoCoolerLiquidationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MonoCoolerLiquidations'] : ['MonoCoolerLiquidations', variables],
    queryFn: fetcher<MonoCoolerLiquidationsQuery, MonoCoolerLiquidationsQueryVariables>(MonoCoolerLiquidationsDocument, variables),
    ...options
  }
    )};

useMonoCoolerLiquidationsQuery.getKey = (variables?: MonoCoolerLiquidationsQueryVariables) => variables === undefined ? ['MonoCoolerLiquidations'] : ['MonoCoolerLiquidations', variables];

export const useInfiniteMonoCoolerLiquidationsQuery = <
      TData = InfiniteData<MonoCoolerLiquidationsQuery>,
      TError = unknown
    >(
      variables: MonoCoolerLiquidationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MonoCoolerLiquidationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MonoCoolerLiquidationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MonoCoolerLiquidationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MonoCoolerLiquidations.infinite'] : ['MonoCoolerLiquidations.infinite', variables],
      queryFn: (metaData) => fetcher<MonoCoolerLiquidationsQuery, MonoCoolerLiquidationsQueryVariables>(MonoCoolerLiquidationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMonoCoolerLiquidationsQuery.getKey = (variables?: MonoCoolerLiquidationsQueryVariables) => variables === undefined ? ['MonoCoolerLiquidations.infinite'] : ['MonoCoolerLiquidations.infinite', variables];


useMonoCoolerLiquidationsQuery.fetcher = (variables?: MonoCoolerLiquidationsQueryVariables) => fetcher<MonoCoolerLiquidationsQuery, MonoCoolerLiquidationsQueryVariables>(MonoCoolerLiquidationsDocument, variables);

export const MonoCoolerActivityByTypeDocument = `
    query MonoCoolerActivityByType($type: String!, $first: Int = 20) {
  monoCoolerActivities(
    first: $first
    where: {type: $type}
    orderBy: timestamp
    orderDirection: desc
  ) {
    id
    type
    account {
      address
    }
    amount
    collateral
    debt
    txHash
    timestamp
  }
}
    `;

export const useMonoCoolerActivityByTypeQuery = <
      TData = MonoCoolerActivityByTypeQuery,
      TError = unknown
    >(
      variables: MonoCoolerActivityByTypeQueryVariables,
      options?: Omit<UseQueryOptions<MonoCoolerActivityByTypeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MonoCoolerActivityByTypeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MonoCoolerActivityByTypeQuery, TError, TData>(
      {
    queryKey: ['MonoCoolerActivityByType', variables],
    queryFn: fetcher<MonoCoolerActivityByTypeQuery, MonoCoolerActivityByTypeQueryVariables>(MonoCoolerActivityByTypeDocument, variables),
    ...options
  }
    )};

useMonoCoolerActivityByTypeQuery.getKey = (variables: MonoCoolerActivityByTypeQueryVariables) => ['MonoCoolerActivityByType', variables];

export const useInfiniteMonoCoolerActivityByTypeQuery = <
      TData = InfiniteData<MonoCoolerActivityByTypeQuery>,
      TError = unknown
    >(
      variables: MonoCoolerActivityByTypeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MonoCoolerActivityByTypeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MonoCoolerActivityByTypeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MonoCoolerActivityByTypeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MonoCoolerActivityByType.infinite', variables],
      queryFn: (metaData) => fetcher<MonoCoolerActivityByTypeQuery, MonoCoolerActivityByTypeQueryVariables>(MonoCoolerActivityByTypeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMonoCoolerActivityByTypeQuery.getKey = (variables: MonoCoolerActivityByTypeQueryVariables) => ['MonoCoolerActivityByType.infinite', variables];


useMonoCoolerActivityByTypeQuery.fetcher = (variables: MonoCoolerActivityByTypeQueryVariables) => fetcher<MonoCoolerActivityByTypeQuery, MonoCoolerActivityByTypeQueryVariables>(MonoCoolerActivityByTypeDocument, variables);

export const MonoCoolerGlobalStateDocument = `
    query MonoCoolerGlobalState {
  monoCoolerGlobalStates(first: 1) {
    id
    totalCollateral
    totalDebt
    interestAccumulatorRay
    interestRateWad
    ltvOracle
    liquidationPaused
    borrowsPaused
    treasuryBorrower
    updatedAt
  }
}
    `;

export const useMonoCoolerGlobalStateQuery = <
      TData = MonoCoolerGlobalStateQuery,
      TError = unknown
    >(
      variables?: MonoCoolerGlobalStateQueryVariables,
      options?: Omit<UseQueryOptions<MonoCoolerGlobalStateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MonoCoolerGlobalStateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MonoCoolerGlobalStateQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MonoCoolerGlobalState'] : ['MonoCoolerGlobalState', variables],
    queryFn: fetcher<MonoCoolerGlobalStateQuery, MonoCoolerGlobalStateQueryVariables>(MonoCoolerGlobalStateDocument, variables),
    ...options
  }
    )};

useMonoCoolerGlobalStateQuery.getKey = (variables?: MonoCoolerGlobalStateQueryVariables) => variables === undefined ? ['MonoCoolerGlobalState'] : ['MonoCoolerGlobalState', variables];

export const useInfiniteMonoCoolerGlobalStateQuery = <
      TData = InfiniteData<MonoCoolerGlobalStateQuery>,
      TError = unknown
    >(
      variables: MonoCoolerGlobalStateQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MonoCoolerGlobalStateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MonoCoolerGlobalStateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MonoCoolerGlobalStateQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MonoCoolerGlobalState.infinite'] : ['MonoCoolerGlobalState.infinite', variables],
      queryFn: (metaData) => fetcher<MonoCoolerGlobalStateQuery, MonoCoolerGlobalStateQueryVariables>(MonoCoolerGlobalStateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMonoCoolerGlobalStateQuery.getKey = (variables?: MonoCoolerGlobalStateQueryVariables) => variables === undefined ? ['MonoCoolerGlobalState.infinite'] : ['MonoCoolerGlobalState.infinite', variables];


useMonoCoolerGlobalStateQuery.fetcher = (variables?: MonoCoolerGlobalStateQueryVariables) => fetcher<MonoCoolerGlobalStateQuery, MonoCoolerGlobalStateQueryVariables>(MonoCoolerGlobalStateDocument, variables);

export const MonoCoolerHistoricalDataDocument = `
    query MonoCoolerHistoricalData($first: Int = 100) {
  monoCoolerGlobalSnapshots(
    first: $first
    orderBy: timestamp
    orderDirection: asc
  ) {
    id
    timestamp
    totalCollateral
    totalDebt
    interestRateWad
  }
}
    `;

export const useMonoCoolerHistoricalDataQuery = <
      TData = MonoCoolerHistoricalDataQuery,
      TError = unknown
    >(
      variables?: MonoCoolerHistoricalDataQueryVariables,
      options?: Omit<UseQueryOptions<MonoCoolerHistoricalDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MonoCoolerHistoricalDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MonoCoolerHistoricalDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MonoCoolerHistoricalData'] : ['MonoCoolerHistoricalData', variables],
    queryFn: fetcher<MonoCoolerHistoricalDataQuery, MonoCoolerHistoricalDataQueryVariables>(MonoCoolerHistoricalDataDocument, variables),
    ...options
  }
    )};

useMonoCoolerHistoricalDataQuery.getKey = (variables?: MonoCoolerHistoricalDataQueryVariables) => variables === undefined ? ['MonoCoolerHistoricalData'] : ['MonoCoolerHistoricalData', variables];

export const useInfiniteMonoCoolerHistoricalDataQuery = <
      TData = InfiniteData<MonoCoolerHistoricalDataQuery>,
      TError = unknown
    >(
      variables: MonoCoolerHistoricalDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MonoCoolerHistoricalDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MonoCoolerHistoricalDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MonoCoolerHistoricalDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MonoCoolerHistoricalData.infinite'] : ['MonoCoolerHistoricalData.infinite', variables],
      queryFn: (metaData) => fetcher<MonoCoolerHistoricalDataQuery, MonoCoolerHistoricalDataQueryVariables>(MonoCoolerHistoricalDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMonoCoolerHistoricalDataQuery.getKey = (variables?: MonoCoolerHistoricalDataQueryVariables) => variables === undefined ? ['MonoCoolerHistoricalData.infinite'] : ['MonoCoolerHistoricalData.infinite', variables];


useMonoCoolerHistoricalDataQuery.fetcher = (variables?: MonoCoolerHistoricalDataQueryVariables) => fetcher<MonoCoolerHistoricalDataQuery, MonoCoolerHistoricalDataQueryVariables>(MonoCoolerHistoricalDataDocument, variables);

export const ProtocolIncomeDocument = `
    query ProtocolIncome($first: Int = 1000, $skip: Int = 0) {
  defaultStats_collection(interval: day, first: $first, skip: $skip) {
    totalCollateralClaimed
    totalValueClaimed
    totalPrincipalDefaulted
    timestamp
  }
  extensionStats_collection(interval: day, first: $first, skip: $skip) {
    totalNewInterest
    timestamp
  }
  repaymentStats_collection(interval: day, first: $first, skip: $skip) {
    timestamp
    totalInterestPaid
  }
}
    `;

export const useProtocolIncomeQuery = <
      TData = ProtocolIncomeQuery,
      TError = unknown
    >(
      variables?: ProtocolIncomeQueryVariables,
      options?: Omit<UseQueryOptions<ProtocolIncomeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProtocolIncomeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProtocolIncomeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ProtocolIncome'] : ['ProtocolIncome', variables],
    queryFn: fetcher<ProtocolIncomeQuery, ProtocolIncomeQueryVariables>(ProtocolIncomeDocument, variables),
    ...options
  }
    )};

useProtocolIncomeQuery.getKey = (variables?: ProtocolIncomeQueryVariables) => variables === undefined ? ['ProtocolIncome'] : ['ProtocolIncome', variables];

export const useInfiniteProtocolIncomeQuery = <
      TData = InfiniteData<ProtocolIncomeQuery>,
      TError = unknown
    >(
      variables: ProtocolIncomeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProtocolIncomeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProtocolIncomeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ProtocolIncomeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ProtocolIncome.infinite'] : ['ProtocolIncome.infinite', variables],
      queryFn: (metaData) => fetcher<ProtocolIncomeQuery, ProtocolIncomeQueryVariables>(ProtocolIncomeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteProtocolIncomeQuery.getKey = (variables?: ProtocolIncomeQueryVariables) => variables === undefined ? ['ProtocolIncome.infinite'] : ['ProtocolIncome.infinite', variables];


useProtocolIncomeQuery.fetcher = (variables?: ProtocolIncomeQueryVariables) => fetcher<ProtocolIncomeQuery, ProtocolIncomeQueryVariables>(ProtocolIncomeDocument, variables);

export const TopBorrowDocument = `
    query TopBorrow {
  clearLoanRequestEvents(orderBy: loan__principal, orderDirection: desc, first: 1) {
    loan {
      principal
    }
  }
}
    `;

export const useTopBorrowQuery = <
      TData = TopBorrowQuery,
      TError = unknown
    >(
      variables?: TopBorrowQueryVariables,
      options?: Omit<UseQueryOptions<TopBorrowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TopBorrowQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TopBorrowQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['TopBorrow'] : ['TopBorrow', variables],
    queryFn: fetcher<TopBorrowQuery, TopBorrowQueryVariables>(TopBorrowDocument, variables),
    ...options
  }
    )};

useTopBorrowQuery.getKey = (variables?: TopBorrowQueryVariables) => variables === undefined ? ['TopBorrow'] : ['TopBorrow', variables];

export const useInfiniteTopBorrowQuery = <
      TData = InfiniteData<TopBorrowQuery>,
      TError = unknown
    >(
      variables: TopBorrowQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TopBorrowQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TopBorrowQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<TopBorrowQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['TopBorrow.infinite'] : ['TopBorrow.infinite', variables],
      queryFn: (metaData) => fetcher<TopBorrowQuery, TopBorrowQueryVariables>(TopBorrowDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteTopBorrowQuery.getKey = (variables?: TopBorrowQueryVariables) => variables === undefined ? ['TopBorrow.infinite'] : ['TopBorrow.infinite', variables];


useTopBorrowQuery.fetcher = (variables?: TopBorrowQueryVariables) => fetcher<TopBorrowQuery, TopBorrowQueryVariables>(TopBorrowDocument, variables);

export const TopLooperDocument = `
    query TopLooper {
  borrowerStats_collection(
    first: 1
    orderBy: maxActiveLoans
    orderDirection: desc
  ) {
    maxActiveLoans
    totalLoans
    activeLoans
  }
}
    `;

export const useTopLooperQuery = <
      TData = TopLooperQuery,
      TError = unknown
    >(
      variables?: TopLooperQueryVariables,
      options?: Omit<UseQueryOptions<TopLooperQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TopLooperQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TopLooperQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['TopLooper'] : ['TopLooper', variables],
    queryFn: fetcher<TopLooperQuery, TopLooperQueryVariables>(TopLooperDocument, variables),
    ...options
  }
    )};

useTopLooperQuery.getKey = (variables?: TopLooperQueryVariables) => variables === undefined ? ['TopLooper'] : ['TopLooper', variables];

export const useInfiniteTopLooperQuery = <
      TData = InfiniteData<TopLooperQuery>,
      TError = unknown
    >(
      variables: TopLooperQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TopLooperQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TopLooperQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<TopLooperQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['TopLooper.infinite'] : ['TopLooper.infinite', variables],
      queryFn: (metaData) => fetcher<TopLooperQuery, TopLooperQueryVariables>(TopLooperDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteTopLooperQuery.getKey = (variables?: TopLooperQueryVariables) => variables === undefined ? ['TopLooper.infinite'] : ['TopLooper.infinite', variables];


useTopLooperQuery.fetcher = (variables?: TopLooperQueryVariables) => fetcher<TopLooperQuery, TopLooperQueryVariables>(TopLooperDocument, variables);

export const TopTotalBorrowsDocument = `
    query TopTotalBorrows {
  borrowerStats_collection(
    orderDirection: desc
    orderBy: maxBorrowedValue
    first: 1
  ) {
    maxBorrowedValue
  }
}
    `;

export const useTopTotalBorrowsQuery = <
      TData = TopTotalBorrowsQuery,
      TError = unknown
    >(
      variables?: TopTotalBorrowsQueryVariables,
      options?: Omit<UseQueryOptions<TopTotalBorrowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TopTotalBorrowsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TopTotalBorrowsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['TopTotalBorrows'] : ['TopTotalBorrows', variables],
    queryFn: fetcher<TopTotalBorrowsQuery, TopTotalBorrowsQueryVariables>(TopTotalBorrowsDocument, variables),
    ...options
  }
    )};

useTopTotalBorrowsQuery.getKey = (variables?: TopTotalBorrowsQueryVariables) => variables === undefined ? ['TopTotalBorrows'] : ['TopTotalBorrows', variables];

export const useInfiniteTopTotalBorrowsQuery = <
      TData = InfiniteData<TopTotalBorrowsQuery>,
      TError = unknown
    >(
      variables: TopTotalBorrowsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TopTotalBorrowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TopTotalBorrowsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<TopTotalBorrowsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['TopTotalBorrows.infinite'] : ['TopTotalBorrows.infinite', variables],
      queryFn: (metaData) => fetcher<TopTotalBorrowsQuery, TopTotalBorrowsQueryVariables>(TopTotalBorrowsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteTopTotalBorrowsQuery.getKey = (variables?: TopTotalBorrowsQueryVariables) => variables === undefined ? ['TopTotalBorrows.infinite'] : ['TopTotalBorrows.infinite', variables];


useTopTotalBorrowsQuery.fetcher = (variables?: TopTotalBorrowsQueryVariables) => fetcher<TopTotalBorrowsQuery, TopTotalBorrowsQueryVariables>(TopTotalBorrowsDocument, variables);

export const GetActiveLoansByMaturityDocument = `
    query GetActiveLoansByMaturity($first: Int = 1000, $skip: Int = 0, $principal: BigDecimal = "0", $date: BigInt) {
  coolerLoans(
    first: $first
    skip: $skip
    orderBy: currentExpiryTimestamp
    orderDirection: asc
    where: {principal_gt: $principal, currentExpiryTimestamp_gt: $date}
  ) {
    id
    borrower {
      id
    }
    cooler
    principal
    currentExpiryTimestamp
    interest
    collateral
    loanId
    defaultedClaimEvents {
      collateralPrice
    }
    extendEvents(orderBy: blockTimestamp, orderDirection: desc, first: 1) {
      expiryTimestamp
    }
  }
}
    `;

export const useGetActiveLoansByMaturityQuery = <
      TData = GetActiveLoansByMaturityQuery,
      TError = unknown
    >(
      variables?: GetActiveLoansByMaturityQueryVariables,
      options?: Omit<UseQueryOptions<GetActiveLoansByMaturityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetActiveLoansByMaturityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetActiveLoansByMaturityQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetActiveLoansByMaturity'] : ['GetActiveLoansByMaturity', variables],
    queryFn: fetcher<GetActiveLoansByMaturityQuery, GetActiveLoansByMaturityQueryVariables>(GetActiveLoansByMaturityDocument, variables),
    ...options
  }
    )};

useGetActiveLoansByMaturityQuery.getKey = (variables?: GetActiveLoansByMaturityQueryVariables) => variables === undefined ? ['GetActiveLoansByMaturity'] : ['GetActiveLoansByMaturity', variables];

export const useInfiniteGetActiveLoansByMaturityQuery = <
      TData = InfiniteData<GetActiveLoansByMaturityQuery>,
      TError = unknown
    >(
      variables: GetActiveLoansByMaturityQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetActiveLoansByMaturityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetActiveLoansByMaturityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetActiveLoansByMaturityQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetActiveLoansByMaturity.infinite'] : ['GetActiveLoansByMaturity.infinite', variables],
      queryFn: (metaData) => fetcher<GetActiveLoansByMaturityQuery, GetActiveLoansByMaturityQueryVariables>(GetActiveLoansByMaturityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetActiveLoansByMaturityQuery.getKey = (variables?: GetActiveLoansByMaturityQueryVariables) => variables === undefined ? ['GetActiveLoansByMaturity.infinite'] : ['GetActiveLoansByMaturity.infinite', variables];


useGetActiveLoansByMaturityQuery.fetcher = (variables?: GetActiveLoansByMaturityQueryVariables) => fetcher<GetActiveLoansByMaturityQuery, GetActiveLoansByMaturityQueryVariables>(GetActiveLoansByMaturityDocument, variables);
